/* global braintree */
// #region Import
import productFilters from './partials/productFilters.hbs';
import productGalleryUpdate from './partials/productGalleryUpdate.hbs';
import productGalleryThumbnail from './partials/productGalleryThumbnail.hbs';
import productHeader from './partials/productHeader.hbs';
import productDescription from './partials/productDescription.hbs';
import productDescriptionUpdate from './partials/productDescriptionUpdate.hbs';
import productPriceUpdate from './partials/productPriceUpdate.hbs';
import productPriceStickyHeader from './partials/productPriceStickyHeader.hbs';
import productKitStickyHeader from './partials/productKitStickyHeader.hbs';
import productPackStickyHeader from './partials/productPackStickyHeader.hbs';
import productKit from './partials/product-kit-details.hbs';
import productKitContents from './partials/product-kit-contents.hbs';
import productBiomeKits from './partials/product-biome-kits.hbs';
import productBiomeKitPrice from './partials/product-biome-kit-price.hbs';
import productBiomeProducts from './partials/product-biome-products.hbs';
import productBiomeKitDetails from './partials/product-biome-kit-details.hbs';
import productBiomeProductPrice from './partials/product-biome-product-price.hbs';
import productKitAsProductPrice from './partials/product-kit-as-product-price.hbs';
import productGallery from './partials/productGallery.hbs';
import productFacets from './partials/productFacets.hbs';
import crossSellCards from './partials/crossSellCards.hbs';
import productPrice from './partials/productPrice.hbs';
import productPricePack from './partials/productPricePack.hbs';
import productPriceKit from './partials/productPriceKit.hbs';
import * as cartService from '/source/js/services/cartService';
import { showSpinner as loadSpinner, hideSpinner as stopSpinner } from '/source/_patterns/01-components/spinner/spinner';
import { getFractionCurrencyFormatter, getCurrencyFormatter } from '/source/js/utils/marketUtil';
import productImageBtn from './partials/productImageBtn.hbs';
import productRadioBtn from './partials/productRadioBtn.hbs';
import productMobileList from './partials/productMobileList.hbs';
import { getPackRequest } from '../product-pack/product-pack';
import { IS_ACTIVE, IS_HIDDEN, IS_DISABLED_MOBILE } from '/source/js/base/baseClasses';
import * as inventoryService from '/source/js/services/inventoryService';
import { replaceQueryString } from '/source/js/utils/historyUtil.js';
import { setDataForAllProducts, productDetails, addGtmTagToCart, removeFromCart, addGlobalQueryIdToRequest, addGtmTagForEditCart} from '/source/js/gtm/IsaGtmCommerce';
import comingSoon from './partials/_coming_soon.hbs';
import infoBadge from './partials/_info_badge.hbs';
import labelBadge from './partials/_label_badge.hbs';
import { hideCartModalShoppingContext } from '/source/_patterns/01-components/cart-ribbon/cart-ribbon';
import * as recommendedCartService from '/source/js/services/recommendedCartService';
import * as toast from '/source/js/utils/toastUtil'; //eslint-disable-line
import {
    ADD_TO_CART_LOADING_STARTED_MESSAGE,
    ADD_TO_CART_LOADING_COMPLETED_MESSAGE,
    ADD_TO_CART_LOADING_ERROR_MESSAGE,
    CREATE_COPY_LINK_STARTED_MESSAGE,
    CREATE_COPY_LINK_COMPLETED_MESSAGE,
    CREATE_COPY_LINK_ERROR_MESSAGE,
    UPDATE_TO_CART_LOADING_STARTED_MESSAGE,
    UPDATE_TO_CART_LOADING_COMPLETED_MESSAGE,
    UPDATE_TO_CART_LOADING_ERROR_MESSAGE
} from '../common/common';
// #endregion Import

// #region Variables
const PRODUCT_LABEL = 'product__input';
const DATA_FILTERBY = 'label';
const FILTER = 'filter';
const FILTER_BY = 'filter-by';
const IS_DISABLED = 'is--disabled';
const REVIEW_SECTION = '#ReviewsSection';
const TRY_ONCE = '#tryonce';
const PRODUCTID_QS = 'pid';
const BPCRETAIL = 'Brand-Partner-Customer-Retail-Checkout';
const RETAIL_CHECKOUT = 'Retail-Checkout';
const PC_NMR = 'PC-NewMemberRewards';
const PC_NM = 'PC-NewMember';

let crossSellData;
let isAuthenticatedUser = false;
let displayBV = false;
let productData;
let selectedProduct;
let selectedKitProduct;
let customProductQty;
let fractionCurrencyFormatter;
let currencyFormatter;
let isEdit;
let editOnLoadQuantity;
let isTryOnceProduct;
let marketSettings = window.currentMarketSettingsContext; // eslint-disable-line
let $productGallery;
let $productGalleryThumbnailSection;
let $productDietaryRestrictions;
let $productDetailsDescription;
let $productPriceDetail;
let $productPriceStickyHeaderSection;
let $addToCartType;
let outOfStockProductIds = [];
let updatedQuantity;
let updatedCheckedPriceType;
let secondaryFacets;
let singleFacet;
let multiFacets;
let filtering;
let filterFacetId;
let facets;
let assets;
let tier;
let productId;
let $product = $('.product');
productData = $product.data('product-details');
let isNotAmbassador;
let $productKit = $('.product__kit');
let $productHeading = $('.product__heading');
let $filterInput = $(`.${FILTER}`).find('input');
let checkRender;
let upgradedSectionOffSet = 0;
let scrollTimeout = 0;
var forAmbassaorOnly = $product.data('is-ambassador');
isNotAmbassador = !!(forAmbassaorOnly === 'false' || forAmbassaorOnly === 'False');
productData = { ...productData, IsNotAmbassador: isNotAmbassador };
let infoBadgeDiv;
let labelBadgeDiv;
let createLinkList = [];
let QUERY_ID;
let INDEX_NAME;

// #endregion Variables

// helper function
function presaleQuantityErrorMessage(presaleResult) {
    var presalemsg = `<div class="product-unavailable-message presaleQuantity-errormsg">
    <div class="product__unavailable">
        <p class="product-error product-error--unavailable" data-status="true">
        <span class="error-icon-unavailable"><i class="fal fa-exclamation-circle form__password-icon form__password-icon--error" aria-hidden="true"></i></span>
        <span class="psQuantity-errormsg">${presaleResult}</span></p>
    </div>
</div>`;

    $('.product-unavailable-message.presaleQuantity-errormsg').remove();
    $('.product__details .product__price .price__group').after(presalemsg);
    $('.product__details .product__price .price__group .addToCart').prop('disabled', true);
    $('.product__details .product__price .price__group .addToCart').removeClass('addToCart');
    $('.product__details .product__price .price__group .js-build-pack').prop('disabled', true);
    $('.product__details .product__price .price__group .js-build-pack').removeClass('js-build-pack');
}
// #region Cart
async function addKitToCart() {
    let request = {};
    if(productData.BundleConfiguration) {
        request = getPackRequest(productData.BundleConfiguration);
    } else {
        request = getPackRequest(selectedProduct);
    }

    if(!request.FamilyId && productData.ProductFamily[0]) {
        request.FamilyId = productData.ProductFamily[0].ID; // add family Id so it can be validated in backend
        request.IsKit = true;
    }

    if(!isEdit) {
        try {
            loadSpinner(ADD_TO_CART_LOADING_STARTED_MESSAGE);
            if($(TRY_ONCE).length > 0) {
                request.TryOnce = $(TRY_ONCE).is(':checked');
            }

            var paramProd = new URLSearchParams(window.location.search);
            var prodId = paramProd.get('pid');
            var prod = productData.Products.filter(function (product) {
                return product.ID === prodId;
            });

            if(prod.length > 0 && prod[0].PresaleData.IsValidPresaleItem && prod[0].PresaleData.CanPurchase) {
                var presalerequest = {
                    'productSku': prod[0].Sku,
                    'maxQuantity': prod[0].PresaleData.PresaleMax
                };

                const presaleResult = await cartService.presaleQuantityCheck(presalerequest);
                if(presaleResult.CanAddToCart) {
                    const result = await cartService.addPackToCart(addQueryIdToRequest(request));
                    if(result.IsSuccessful) {
                        stopSpinner(ADD_TO_CART_LOADING_COMPLETED_MESSAGE);
                        setGAProperties(result);
                        cartService.updateQSForMergeCart();
                        if(result.RedirectString) {
                            window.location = result.RedirectString;
                        } else {
                            hideCartModalShoppingContext(request.PriceType);
                            showCartItemAdded(result, request.quantity);
                            if(productData.DisplayTryOnce && productData.HideTryOnce && $('.tryonce').length > 0) {
                                $('.tryonce').show();
                                productData.HideTryOnce = false;
                            }
                            productData.CustomerType = getCustomerType();
                            if($('.price__block').length > 1) {
                                if(request.PriceType.includes('Brand-Partner-Customer-Retail')) {
                                    $addToCartType = $(`.price__block:not(.${BPCRETAIL})`);
                                    $addToCartType.remove();
                                } else {
                                    $addToCartType = $(`.price__block:not(.${request.PriceType})`);
                                    $addToCartType.remove();
                                }
                            }
                            updateCartCount(result);
                        }
                    } else {
                        stopSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
                        addToCartFailed(result);
                    }
                } else {
                    stopSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
                    presaleQuantityErrorMessage(presaleResult.Message);
                }
            } else {
                const result = await cartService.addPackToCart(addQueryIdToRequest(request));
                if(result.IsSuccessful) {
                    stopSpinner(ADD_TO_CART_LOADING_COMPLETED_MESSAGE);
                    setGAProperties(result);
                    cartService.updateQSForMergeCart();
                    if(result.RedirectString) {
                        window.location = result.RedirectString;
                    } else {
                        hideCartModalShoppingContext(request.PriceType);
                        showCartItemAdded(result, request.quantity);
                        if(productData.DisplayTryOnce && productData.HideTryOnce && $('.tryonce').length > 0) {
                            $('.tryonce').show();
                            productData.HideTryOnce = false;
                        }
                        productData.CustomerType = getCustomerType();
                        if($('.price__block').length > 1) {
                            if(request.PriceType.includes('Brand-Partner-Customer-Retail')) {
                                $addToCartType = $(`.price__block:not(.${BPCRETAIL})`);
                                $addToCartType.remove();
                            } else {
                                $addToCartType = $(`.price__block:not(.${request.PriceType})`);
                                $addToCartType.remove();
                            }
                        }
                        updateCartCount(result);
                    }
                } else {
                    stopSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
                    addToCartFailed(result);
                }
            }
        } catch (ex) {
            console.error(ex);
            showErrorMessage('Unexpected error');
            stopSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
        }
    } else {
        request.CartlineId = $('.product').data('clid');
        loadSpinner(UPDATE_TO_CART_LOADING_STARTED_MESSAGE);
        try {
            const result = await cartService.editPackCartLine(request);
            if(result.IsSuccessful) {
                stopSpinner(UPDATE_TO_CART_LOADING_COMPLETED_MESSAGE);
                setGAProperties(result);
                window.location.href = $('.product').data('cartpageurl');
            } else {
                stopSpinner(UPDATE_TO_CART_LOADING_ERROR_MESSAGE);
                addToCartFailed(result);
            }
        } catch (ex) {
            console.error(ex);
            showErrorMessage('Unexpected error');
            stopSpinner(UPDATE_TO_CART_LOADING_ERROR_MESSAGE);
        }
    }
}

async function addCustomProductToCart() {
    $product = $('.product');
    if(!$product.length) return;
    initCurrencyFormatter();
    productData = $product.data('custom-product-details');
    selectedProduct = productData.Products[0];
    isAuthenticatedUser = productData.IsAuthenticatedUser;
    displayBV = productData.DisplayBV;
    customProductQty = 1;
    if(selectedProduct.PricesAndBV.length === 1) {
        $("input[name='priceType']:checked").attr('id', selectedProduct.PricesAndBV[0].Tier);
    }
    await addProductToCart();
}

function getQuantity() {
    return $('.price__single-quantity-selector').find('input[name="quantity"]').val() || customProductQty;
}

async function addProductToCart() {
    let quantity = getQuantity();
    let priceType = $("input[name='priceType']:checked").attr('id');
    let selectedPriceTier = selectedProduct.PricesAndBV.find(x => x.Tier === priceType);
    if(!selectedPriceTier && selectedProduct.PricesAndBV.length === 1) {
        selectedPriceTier = selectedProduct.PricesAndBV[0];
    }

    if(!isEdit) {
        loadSpinner(ADD_TO_CART_LOADING_STARTED_MESSAGE);
        let tryOnce = false;
        if($(TRY_ONCE).length > 0) {
            tryOnce = $(TRY_ONCE).is(':checked');
        }
        try {
            var paramProd = new URLSearchParams(window.location.search);
            var prodId = paramProd.get('pid');
            var prod = productData.Products.filter(function (product) {
                return product.ID === prodId;
            });

            if(prod.length > 0 && prod[0].PresaleData.IsValidPresaleItem && prod[0].PresaleData.CanPurchase) {
                var presalerequest = {
                    'productSku': prod[0].Sku,
                    'maxQuantity': prod[0].PresaleData.PresaleMax
                };

                const presaleResult = await cartService.presaleQuantityCheck(presalerequest);

                if(presaleResult.CanAddToCart) {
                    const result = await cartService.addToCart(addQueryIdToRequest({
                        FamilyId: productData.ProductFamily[0].ID,
                        FamilyName: selectedProduct.Name,
                        ProductId: `Isagenix_Master|${selectedProduct.ID || selectedProduct.Id}|`,
                        Sku: selectedProduct.Sku,
                        Quantity: quantity,
                        ProductPageRelativeUrl: window.location.pathname,
                        PriceType: priceType,
                        Price: selectedPriceTier.Price,
                        TryOnce: tryOnce
                    }));
                    stopSpinner(ADD_TO_CART_LOADING_STARTED_MESSAGE);

                    if(result.IsSuccessful) {
                        setGAProperties(result);
                        cartService.updateQSForMergeCart();
                        if(result.RedirectString) {
                            window.location = result.RedirectString;
                        } else {
                            showCartItemAdded(result, quantity);
                            if(productData.DisplayTryOnce && productData.HideTryOnce && $('.tryonce').length > 0) {
                                productData.HideTryOnce = false;
                            }
                            productData.CustomerType = getCustomerType();
                            if($('.price__block').length > 1) {
                                if(priceType.includes('Brand-Partner-Customer-Retail')) {
                                    $addToCartType = $(`.price__block:not(.${BPCRETAIL})`);
                                    $addToCartType.remove();
                                } else {
                                    $addToCartType = $(`.price__block:not(.${priceType})`);
                                    $addToCartType.remove();
                                }
                            }
                            hideCartModalShoppingContext(priceType);
                            updateCartCount(result);
                        }
                    } else {
                        addToCartFailed(result);
                    }
                } else {
                    stopSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
                    presaleQuantityErrorMessage(presaleResult.Message);
                }
            } else {
                const result = await cartService.addToCart(addQueryIdToRequest({
                    FamilyId: productData.ProductFamily[0].ID,
                    FamilyName: selectedProduct.Name,
                    ProductId: `Isagenix_Master|${selectedProduct.ID || selectedProduct.Id}|`,
                    Sku: selectedProduct.Sku,
                    Quantity: quantity,
                    ProductPageRelativeUrl: window.location.pathname,
                    PriceType: priceType,
                    Price: selectedPriceTier.Price,
                    TryOnce: tryOnce
                }));
                if(result.IsSuccessful) {
                    stopSpinner(ADD_TO_CART_LOADING_COMPLETED_MESSAGE);
                    setGAProperties(result);
                    cartService.updateQSForMergeCart();
                    if(result.RedirectString) {
                        window.location = result.RedirectString;
                    } else {
                        showCartItemAdded(result, quantity);
                        if(productData.DisplayTryOnce && productData.HideTryOnce && $('.tryonce').length > 0) {
                            productData.HideTryOnce = false;
                        }
                        productData.CustomerType = getCustomerType();
                        if($('.price__block').length > 1) {
                            if(priceType.includes('Brand-Partner-Customer-Retail')) {
                                $addToCartType = $(`.price__block:not(.${BPCRETAIL})`);
                                $addToCartType.remove();
                            } else {
                                $addToCartType = $(`.price__block:not(.${priceType})`);
                                $addToCartType.remove();
                            }
                        }
                        hideCartModalShoppingContext(priceType);
                        updateCartCount(result);
                    }
                } else {
                    stopSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
                    addToCartFailed(result);
                }
            }
        } catch (ex) {
            console.error(ex);
            showErrorMessage('Unexpected error');
            stopSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
        }
    } else {
        loadSpinner(UPDATE_TO_CART_LOADING_STARTED_MESSAGE);
        try {
            let tryOnce = false;
            if($(TRY_ONCE).length > 0) {
                tryOnce = $(TRY_ONCE).is(':checked');
            }
            const result = await cartService.editCartLine({
                FamilyId: productData.ProductFamily[0].ID,
                FamilyName: selectedProduct.Name,
                ProductId: `Isagenix_Master|${selectedProduct.ID}|`,
                CartlineId: $('.product').data('clid'),
                Quantity: quantity,
                ProductPageRelativeUrl: window.location.pathname,
                TryOnce: tryOnce
            });

            if(result.IsSuccessful) {
                stopSpinner(UPDATE_TO_CART_LOADING_COMPLETED_MESSAGE);
                setGAProperties(result);
                window.location.href = $('.product').data('cartpageurl');
                if($('.price__block').length > 1) {
                    $addToCartType = $('.price__block.PC');
                    $addToCartType.remove();
                }
            } else {
                stopSpinner(UPDATE_TO_CART_LOADING_ERROR_MESSAGE);
                addToCartFailed(result);
            }
        } catch (ex) {
            console.error(ex);
            showErrorMessage('Unexpected error');
            stopSpinner(UPDATE_TO_CART_LOADING_ERROR_MESSAGE);
        }
    }
}

async function addToCart(elem) {
    if(selectedKitProduct) {
        selectedProduct = selectedKitProduct;
    }

    if(!selectedProduct) {
        console.error('selectedProduct is null');
        return;
    }

    hideErrorMessage();

    if(productData.BundleConfiguration || selectedProduct.BundleConfigurationId) {
        addKitToCart();
    } else {
        addProductToCart();
    }
}

function pushItemToExistingShareLinkArray(sku, result) {
    var shareLinkItem = { ProductSku: sku, ShareCode: result.ShareLinkCode, ShareLinkId: result.ShareLinkId, ShareLinkUrl: result.ShareLinkUrl, ShareType: 2 };
    createLinkList.push(shareLinkItem);
}

async function saveProductToShareLink() {
    if(!$('.addIndividualLink').hasClass('copyShareLink')) {
        loadSpinner(CREATE_COPY_LINK_STARTED_MESSAGE);
        try {
            const result = await recommendedCartService.saveShareLink({
                productSku: selectedProduct.Sku
            });
            if(result.IsSuccessful) {
                stopSpinner(CREATE_COPY_LINK_COMPLETED_MESSAGE);
                UpdateCreateLinkButton();
                pushItemToExistingShareLinkArray(selectedProduct.Sku, result);
                await navigator.clipboard.writeText(result.ShareLinkUrl);
            } else {
                stopSpinner(CREATE_COPY_LINK_ERROR_MESSAGE);
                if(result.MaximumShareLinkCartsCount && result.MaximumShareLinkCartsCount > 0 && result.Messages.find(m => m.CommerceCode === 'CanCreateShareLinkCartsFailed')) {
                    $('#maximumRecommendedModal').removeClass('d-none');
                    $('#BPMaximumLinksAllowedMessage').text($('#BPMaxLinksMessageWithoutCount').text().replace('{#}', result.MaximumShareLinkCartsCount.toString()));
                } else {
                    const message = result.Messages.find(m => m.CommerceCode === 'ShareLinkProductCreateFailed' && m.MessageText !== null);
                    if(message) {
                        console.log('Create A Link Failed:', message.MessageText);
                        toast.Error(message.MessageText);
                    }
                }
            }
        } catch (ex) {
            console.error(ex);
            toast.Error(productData.Labels.CopyLinkFailed);
            stopSpinner(CREATE_COPY_LINK_ERROR_MESSAGE);
        }
    }
}

export function getToastMessage(result) {
    if(result && result.Messages) {
        let toastMsg = result.Messages.find(x => x.IsToast === true);
        if(toastMsg) return toastMsg.MessageText;
        return '';
    }
    return '';
}

async function createALink() {
    if(selectedKitProduct) {
        selectedProduct = selectedKitProduct;
    }

    if(!selectedProduct) {
        console.error('selectedProduct is null');
        return;
    }

    hideErrorMessage();
    saveProductToShareLink();
}

async function copyShareLink() {
    if(selectedKitProduct) {
        selectedProduct = selectedKitProduct;
    }
    if(!selectedProduct) {
        console.error('selectedProduct is null');
        return;
    }
    try {
        let shareLinkFound = createLinkList.find(p => p.ProductSku === selectedProduct.Sku);
        if(selectedProduct.ShareLinkCode || shareLinkFound) {
            if(shareLinkFound) {
                UpdateCreateLinkButton();
                await navigator.clipboard.writeText(shareLinkFound.ShareLinkUrl);
            } else {
                await navigator.clipboard.writeText(selectedProduct.ShareCode);
            }
        }
    } catch (ex) {
        toast.Error(productData.Labels.CopyLinkFailed);
    }
}

function UpdateCreateLinkButton() {
    const button = $('.sticky-button-cart-add');
    $(button).removeClass('addIndividualLink');
    $(button).removeClass('copyShareLink');
    $(button).addClass('linkCopied');
    $(button).text(productData.Labels.LinkCopied);
    let timeoutId = setTimeout(function () {
        clearTimeout(timeoutId);
        $(button).removeClass('linkCopied');
        $(button).addClass('copyShareLink');
        $(button).text(productData.Labels.CopyLink);
    }, 4000);
}

function updateCartCount(result) {
    var currCartItems = document.getElementById('hidden-cartItem-count');
    if(currCartItems) {
        currCartItems.value = result.QuantityTotal;
    }
}

function setGAProperties(result) {
    if(result.GoogleAnalyticsProperties) {
        window.ga_props = window.ga_props || [];
        window.ga_props.push(result.GoogleAnalyticsProperties);
        addGtmTagToAddToCart();
    }
}

async function addCrossSellProductToCart(selectedProduct) {
    let quantity = 1;
    loadSpinner(ADD_TO_CART_LOADING_STARTED_MESSAGE);
    let cleanUrl = selectedProduct.Url;
    if(selectedProduct.Url.indexOf('?') >= 0) {
        cleanUrl = cleanUrl.substring(0, cleanUrl.indexOf('?'));
    }

    try {
        let result;

        // TODO: Tech Debt
        // Refactor to shared file
        // duplicated code too many times across files
        if(selectedProduct.IsKit) {
            result = await cartService.addKitToCart(addQueryIdToRequest({
                FamilyId: selectedProduct.FamilyId,
                ProductId: `Isagenix_Master|${selectedProduct.Id}|`,
                BundleConfigurationId: selectedProduct.BundleConfigurationId,
                Sku: selectedProduct.Sku,
                Quantity: quantity,
                ProductPageRelativeUrl: cleanUrl,
                PriceType: selectedProduct.DefaultPriceType,
                ProductFamilyDisplayName: selectedProduct.ProductFamilyDisplayName,
                TryOnce: false,
                IsCrossSell: true
            }));
        } else {
            result = await cartService.addToCart(addQueryIdToRequest({
                FamilyId: selectedProduct.FamilyId,
                FamilyName: selectedProduct.Name,
                ProductId: `Isagenix_Master|${selectedProduct.Id}|`,
                Quantity: quantity,
                ProductPageRelativeUrl: cleanUrl,
                PriceType: selectedProduct.DefaultPriceType,
                TryOnce: false,
                IsCrossSell: true
            }));
        }

        if(result.IsSuccessful) {
            stopSpinner(ADD_TO_CART_LOADING_COMPLETED_MESSAGE);
            setGAProperties(result);
            cartService.updateQSForMergeCart();
            if(result.RedirectString) {
                window.location.href = result.RedirectString;
            }
            hideCartModalShoppingContext(selectedProduct.DefaultPriceType);
            updateSubHeader(result);
        } else {
            stopSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
            console.error(result);
            addToCartFailed(result);
        }
    } catch (ex) {
        console.error(ex);
        stopSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
    }
}

function crossSellAddProduct() {
    let $itemAddedToCart = $('#ItemAddedToCart').val();
    let $crossSellCard = $(this).closest('.isa-modal__product');
    let $crossSellProductId = $(this).attr('id');
    let crossSellselectedProduct = (!crossSellData) ? null : crossSellData.find(item => item.Id === $crossSellProductId);
    if(!crossSellselectedProduct) return;

    $crossSellCard.prepend(`<div class="card-selected">
    <i class="fal fa-circle-check icon-circle-check-whiteBG mr-md"></i>
    <h4>${$itemAddedToCart}</h4></div>`);

    addCrossSellProductToCart(crossSellselectedProduct);
}

function crossSellAddPack() {
    let $href = $(this).siblings('.crossSell-anchor').attr('href');
    $href = $href + '&open=1&iscrosssell=1';
    window.location.href = $href;
}

function updateCrossSellCards(result) {
    let $modalSubheader = ('#crossSellSubHeader');
    $($modalSubheader).html('');
    let $youMightAlsoEnjoy = $('#YouMightAlsoEnjoy').val();

    if(result.CrossSellProducts && result.CrossSellProducts.length) {
        crossSellData = result.CrossSellProducts;
        let $crossSellResult = {
            products: result.CrossSellProducts,
            isTaxInclusive: result.IsTaxInclusive,
            labels: {
                unavailable: $('#Unavailable').val(),
                buildMyPack: $('#BuildMyPack').val(),
                addToCart: $('#AddToCart').val(),
                taxInclusivePriceText: $('#hdnTaxInclusiveText').val()
            }
        };

        $($modalSubheader).html($youMightAlsoEnjoy);
        let $modalBlock = $('.cross-sell-modal');
        let $crossSellProducts = crossSellCards($crossSellResult);
        $modalBlock.empty().append($crossSellProducts);

        result.CrossSellProducts.forEach(function (product) {
            if(product && product.IsCheckStock) {
                checkCrossSellStock(product.Id);
            }
        });
    }
}

async function checkCrossSellStock(productId) {
    let $unavailable = $('#Unavailable').val();
    let idsToCheck = [productId];
    var response = await inventoryService.getUnavailableInventory(idsToCheck);
    if(response && response.length > 0) {
        $('#' + productId).find('.buttonCrossSell').addClass('card-button-disable').attr('disabled', 'disabled').text($unavailable);
        $('#' + productId).find('.buttonCrossSell').removeClass('crossSellAddProduct');
    }
}

function showCartItemAdded(result, quantity) {
    $('.cartModal .isa-modal__product-name').text(result.Name || result.ProductName);

    let $productMeta = $('.cartModal .isa-modal__product-meta');
    let $productImage = $('.isa-modal__product-image');

    if(result.ProductImage) {
        $productImage.attr('src', result.ProductImage);
    }

    $('.cartModal .isa-modal__product-meta').children().detach();
    $productMeta = $('.cartModal .isa-modal__product-meta');
    if(result.ProductFacetList && result.ProductFacetList.length) {
        result.ProductFacetList.forEach(function (facet) {
            if(facet.Value) {
                $productMeta.append(`<div class="isa-modal__product-meta-item" >
                <div><span>${facet.Name}:</span></div>
                <div><span style="font-weight: bold; word-wrap: break-word">${facet.Value}</span></div>
                </div>`);
            }
        });
    } else if(result.Facets && result.Facets.length) {
        result.Facets.forEach(function (facet) {
            if(facet.Value) {
                $productMeta.append(`<div class="isa-modal__product-meta-item" >
                <div><span>${facet.Name}:</span></div>
                <div><span style="font-weight: bold; word-wrap: break-word">${facet.Value}</span></div>
                </div>`);
            }
        });
    }

    let $qtyText = $('#hdnQuantityText').val();
    $productMeta.append(`<div class="isa-modal__product-meta-item" >
    <div><span>${$qtyText}:</span></div>
    <div><span style="font-weight: bold; word-wrap: break-word">${quantity}</span></div>
    </div>`);
    if(result.TryOnce) {
        $productMeta.append(
            `<div class="tryonce row" style="text-align:left">
            <div class="col-lg-12 col-md-12 col-sm-12"><span style="">${productData.Labels.NextOrderOnlyLabel}</span>
            <button type="button" class="btn btn-tryonce" data-toggle="tooltip" data-placement="top" data-html="true" title="" data-original-title="${productData.Labels.NextOrderOnlyTooltipMsg}">
                
                <i class="fal fa-circle-info tooltip32 price__icon price__icon--exclamation"></i>
            </button></div>`);
    }
    if(marketSettings.CurrencySymbolAbbreviation) {
        if(result.Subtotal % 1 === 0) {
            $('.isa-modal__cart-total').text(currencyFormatter.format(result.Subtotal).replace(marketSettings.Currency, marketSettings.CurrencySymbolAbbreviation.trim()));
        } else {
            $('.isa-modal__cart-total').text(fractionCurrencyFormatter.format(result.Subtotal).replace(marketSettings.Currency, marketSettings.CurrencySymbolAbbreviation.trim()));
        }
    } else {
        if(result.Subtotal % 1 === 0) {
            $('.isa-modal__cart-total').text(currencyFormatter.format(result.Subtotal));
        } else {
            $('.isa-modal__cart-total').text(fractionCurrencyFormatter.format(result.Subtotal));
        }
    }
    updateSubHeader(result);
    updateCrossSellCards(result);
    $('.cartModal').modal('show');
    loadTooltip();
}

function updateSubHeader(result) {
    let itemCount = result.QuantityTotal || result.TotalItemCount;
    $('.header__cart-items').removeClass('d-none').text(itemCount);
    $('.header__cart-count-items').text(itemCount + ' items in cart');
    let $subHeader = $('.isa-modal__cart .card-subheader');
    if(!$subHeader.length) {
        return;
    }
    let subtitle = $subHeader.data('title');
    subtitle = subtitle.replace('###', itemCount);
    $subHeader.empty().append(subtitle);
}

function addToCartFailed(result) {
    let msg = '';
    if(result.Messages) {
        let msgo = result.Messages.find(msg => msg.DisplayMessage === true);
        if(!msgo) msgo = result.Messages[0];
        if(msgo) msg = msgo.MessageText;
    }
    if(result.ErrorCode && result.Message) msg = result.Message;
    showErrorMessage(msg);
}
// #endregion Cart

function showInput() {
    let $this = $(this);
    let $priceBlock = $('.price__block');
    $priceBlock.removeClass(IS_ACTIVE);
    $this.parents('.price__block').addClass(IS_ACTIVE);
}

function selectedOption() {
    let $this = $(this);
    let option;
    if($this.hasClass('product__input--flavor')) {
        option = $this.siblings('.product__input-text').text();
    } else {
        option = $this.siblings('.product__radio-outline').find('.product__input-text').text();
    }
    $this.parents().children('.product__selected-text').children('span').text(option);
}

function increaseItems() {
    let $this = $(this);
    let max;
    if(selectedProduct) {
        max = selectedProduct.MaxQuantity;
    } else {
        max = selectedKitProduct.MaxQuantity;
    }

    let $decreaseItems = $this.siblings('.decrease-items');
    let num;
    $decreaseItems.removeClass(IS_DISABLED);
    $decreaseItems.attr('aria-disabled', 'false');
    if(getItemNumber($this) < max) {
        num = getItemNumber($this) + 1;
    } else {
        num = getItemNumber($this);
    }
    if(num === max) {
        $this.addClass(IS_DISABLED);
        $this.attr('aria-disabled', 'true');
    }
    $this.siblings('input.quantity-input').val(num);
    updatedQuantity = num;
    updateStickyQuantitySelector($this, num);
}

function decreaseItems() {
    let $this = $(this);
    let $increaseItems = $this.siblings('.increase-items');
    $increaseItems.removeClass(IS_DISABLED);
    $increaseItems.attr('aria-disabled', 'false');
    let num = getItemNumber($this) - 1;
    if(num <= 1) {
        num = 1;
        $this.addClass(IS_DISABLED);
        $this.attr('aria-disabled', 'true');
    }
    $this.siblings('input.quantity-input').val(num);
    updatedQuantity = num;
    updateStickyQuantitySelector($this, num);
}

function checkItemMaxMinQuantity() {
    const currentProductData = selectedProduct || selectedKitProduct;
    const max = currentProductData.MaxQuantity;
    const min = 1;

    let $input = $(this);
    let num = parseInt($input.val(), 10);
    if(isNaN(num)) {
        num = 1;
    }
    num = Math.max(min, Math.min(num, max));
    $input.val(num);

    const $increaseBtn = $input.siblings('.increase-items');
    const $decreaseBtn = $input.siblings('.decrease-items');

    $increaseBtn.toggleClass(IS_DISABLED, num >= max);
    $increaseBtn.attr('aria-disabled', num >= max ? 'true' : 'false');
    $decreaseBtn.toggleClass(IS_DISABLED, num <= min);
    $decreaseBtn.attr('aria-disabled', num <= min ? 'true' : 'false');

    updatedQuantity = num;
    updateStickyQuantitySelector($input, num);
}

function getItemNumber($element) {
    let value = '';
    if($element.hasClass('quantity-input')) {
        value = $element.val();
    } else {
        value = $element.siblings('input').val();
    }
    let num = parseInt(value);
    if(num !== isNaN) {
        return num;
    }
    return 0;
}

function validateItemQuantity() {
    let $this = $(this);
    let qty = getItemNumber($this);
    if(!qty || qty < 0) {
        $this.val(1);
    }
}

function preselectProduct() {
    const params = new URLSearchParams(window.location.search);

    if(params.has('edit')) {
        if(!!productData && !!productData.EditProduct) {
            $('.product').data('clid', productData.EditProduct.CartlineId);
            let pid = productData.EditProduct.ProductId;
            isTryOnceProduct = productData.EditProduct.IsTryOnce;
            if(!productData.BundleConfiguration) {
                displaySelectedProduct(pid);
            } else {
                $('#retailPackBuilderButton').trigger('click');
                $('#retailPackBuilderButtonSticky').trigger('click');
            }
            isEdit = true;
            $(`label.${pid} input[type="radio"]`).trigger('click');
            $(`.price__single-quantity-selector input.price__quantity-sign--amount`).val(productData.EditProduct.Quantity);
            updatedQuantity = productData.EditProduct.Quantity;
            showEditProductCTA();
            editOnLoadQuantity = $('.price__quantity-sign--amount').val();
            return true;
        }
    } else if(!productData.BundleConfiguration) {
        if(params.has(PRODUCTID_QS)) {
            let qsVal = params.get(PRODUCTID_QS);
            $(`label.${qsVal} input`).click();
            displaySelectedProduct(qsVal);
            return true;
        } else if(productData.IsUpgradedPDP) {
            if(productData.Products.length > 0 || (productData.Kits && productData.Kits.length > 0)) {
                let qsVal = productData.Products.length > 0 ? productData.Products[0].ID : productData.Kits[0].Id;
                $(`label.${qsVal} input`).click();
                displaySelectedProduct(qsVal);
                return true;
            }
        } else if(productData.Products.length > 0) {
            displaySelectedProduct(productData.Products[0].ID);
        }
    } else if((productData.Products.length > 1 &&
        (selectedKitProduct || selectedProduct)) ||
        (productData.Products.length > 0 && productData.Kits && productData.Kits.length > 0 && (selectedKitProduct || selectedProduct))) {
        let product = selectedKitProduct || selectedProduct;
        let productId = product.ID || product.Id;
        $(`label.${productId} input`).click();
        displaySelectedProduct(productId);
        return true;
    } else if(productData.BundleConfiguration) {
        if(productData.Products.length && productData.Products[0].IsComingSoon) {
            var context = { Message: productData.Labels.ComingSoonMsg };
            let $productUnavailableMessage = $('.product-unavailable-message');
            let comingSoonHtml = comingSoon(context);
            $productUnavailableMessage.html(comingSoonHtml);
        }

        if(productData.IsUpgradedPDP && multiFacets && $(window).width() < 768) {
            let product = selectedKitProduct || selectedProduct;

            if(product) {
                let productId = product.ID || product.Id;
                $(`label.${productId} input`).click();
                displaySelectedProduct(productId);
                return true;
            }
        }

        return productData.Products.length > 1;
    }
    return false;
}

function showEditProductCTA() {
    if(isEdit) {
        let $addCartBtn = $('.addToCart');
        let $cancelEditBtn = $('.cancel-edit');
        $cancelEditBtn.removeClass('d-none');
        $cancelEditBtn.addClass('is--edit');
        $cancelEditBtn.prop('href', productData.ProductDetailsViewModalModel.CartPageUrl);
        if(!$addCartBtn.prop('disabled')) {
            $addCartBtn.text(productData.EditProduct.SaveChangesText);
        }
    }
}

function checkProductShareLink() {
    let productLabel = productData.Labels;
    let product = selectedKitProduct || selectedProduct;
    let shareLinkFound = createLinkList.some(p => p.ProductSku === product.Sku);
    let buttonClass = shareLinkFound ? '.copyShareLink' : '.addIndividualLink';
    let buttonLabelSelector = $(buttonClass);
    if($(buttonLabelSelector).length > 0) {
        if(product.IsTempUnavailable || product.IsCheckStockAndZeroQuantity) {
            $(buttonLabelSelector).removeClass('copyShareLink');
            $(buttonLabelSelector).removeClass('addIndividualLink');
            $(buttonLabelSelector).addClass('unAvailableLink');
            $(buttonLabelSelector).attr('disabled', true);
            $(buttonLabelSelector).text(productLabel.UnavailableLabel);
        }
    }
}

function checkProductOos(flowTempUnavailable) {
    let $productErrorOos = $('.product-error--oos');
    let $productUnavailable = $('.product-error--unavailable');
    let $productPrice = $('.product__price');
    let $pricePromo = $('.price__promo');
    $productErrorOos.remove();
    let productLabel = productData.Labels;
    let product = selectedKitProduct || selectedProduct;
    let isUnavailable = product.IsTempUnavailable || product.IsComingSoon;
    if(isUnavailable) {
        // checkStatus should have taken care.
        return;
    }
    let tempUnavailableMsg = product && product.TempUnavailableMsg ? product.TempUnavailableMsg : productLabel.TempUnavailable;
    let productId = product ? product.ID || product.Id : '';

    var checkOos = outOfStockProductIds.filter(function (item) {
        return item == productId; // eslint-disable-line
    });
    if(checkOos === undefined || checkOos.length === 0) {
        if(flowTempUnavailable) {
            if(!flowTempUnavailable.msg) {
                $productErrorOos.remove();
                $productUnavailable.remove();
                $productPrice.removeClass('is--oos');
                $productPrice.removeClass('is--disabled');
                $pricePromo.removeClass('d-none');

                if(productData.EditProduct) {
                    $('.addToCart').text(productData.EditProduct.SaveChangesText);
                } else {
                    $('.addToCart').text(`${productLabel.AddToCart}`);
                }

                $('.btn-packbuilder').text(`${productLabel.BuildForMe}`);
                if(!productData.DisableAddToCartButton) {
                    $('.addToCart, .addIndividualLink, .price__quantity-sign, .btn-packbuilder').prop('disabled', false);
                }
            } else {
                displayOutOfStock(productLabel.UnavailableLabel, flowTempUnavailable.msg);
            }
            return;
        }

        $productErrorOos.remove();
        $productPrice.removeClass('is--oos');
        $pricePromo.removeClass('d-none');
    } else {
        displayOutOfStock(productLabel.UnavailableLabel, tempUnavailableMsg);

        // need to set again as above method might have added it.
        $productUnavailable = $('.product-error--unavailable');
        // only render if displayOutOfStock did not already do it
        if($productUnavailable.length === 0) {
            let $noFacets = $('.product__selected--no-facets');
            if($noFacets.length > 0) {
                $noFacets.append(`<p class="product-error--oos"><i class="fal fa-exclamation-circle red900"></i>${tempUnavailableMsg}</p>`);
            }
        }
    }
}

function displayOutOfStock(addToCartButtonText, outOfStockMessage) {
    let $productError = $('.product-error');
    let $pricePromo = $('.price__promo');
    let $productPrice = $('.product__price');

    $productError.remove();
    $pricePromo.addClass('d-none');
    $productPrice.addClass('is--oos');
    $productPrice.addClass('is--disabled');
    $('.addToCart, .addIndividualLink, .btn-packbuilder').text(`${addToCartButtonText}`);
    $('.addToCart, .addIndividualLink, .price__quantity-sign, .btn-packbuilder').attr('disabled', 'disabled');
    $('.product__unavailable').append(`<p class="product-error product-error--unavailable" data-status="${true}" role="alert"><span class="error-icon-unavailable"><i class="fal fa-exclamation-circle red900" aria-hidden="true"></i></span>${outOfStockMessage}</p>`);
    announceUnavailable(outOfStockMessage);
}

function initCurrencyFormatter() {
    fractionCurrencyFormatter = getFractionCurrencyFormatter(marketSettings);
    currencyFormatter = getCurrencyFormatter(marketSettings);
}

function closeMsg() {
    let $this = $(this);
    hideErrorMessage($this);
}

function showErrorMessage(text) {
    $('.error__text').text(text)
        .parents('.error__msg').removeClass(IS_HIDDEN).addClass(IS_ACTIVE);
}

function hideErrorMessage($element) {
    if($element) {
        $element.parents('.error__msg').removeClass(IS_ACTIVE).addClass(IS_HIDDEN);
        $($element).children('.error__text').text('');
    } else {
        $('.error__text').text('').parents('.error__msg').removeClass(IS_ACTIVE).addClass(IS_HIDDEN);
    }
}

function toggleDescription() {
    let productLabel = productData.Labels;
    $('.product__details-description').toggleClass('show-more');
    let text = $('#show-more').text();
    $('#show-more').text(text === `${productLabel.ShowMore}` ? `${productLabel.ShowLess}` : `${productLabel.ShowMore}`);
}

function checkStatus(product = selectedProduct) {
    if(!product) return;
    let productLabel = productData.Labels;
    let isComingSoonInIndividualFLow = product.IsComingSoon && productData.IsIndividualLinkSession;
    let unavailable = product.IsTempUnavailable || product.IsComingSoon;
    if(!unavailable && product.PackGroups) {
        unavailable = product.PackGroups.some(g => g.Products && g.Products.some(p => p.IsTempUnavailable));
    }
    let $productPrice = $('.product__price');
    let $pricePromo = $('.price__promo');
    let $productError = $('.product-error');
    $productError.remove();

    if(unavailable && !isComingSoonInIndividualFLow) {
        let message = product.IsComingSoon
            ? productLabel.ComingSoonMsg
            : productLabel.UnavailableLabel;
        $('.product__unavailable').append(`<p class="product-error product-error--unavailable" data-status="${unavailable}"><span class="error-icon-unavailable"><i class="fal fa-exclamation-circle red900"></i></span>${productLabel.TempUnavailable}</p>`);
        $pricePromo.addClass('d-none');
        $productPrice.addClass('is--disabled');
        $('.addToCart, .addIndividualLink, .btn-packbuilder, .js-build-pack').text(`${message}`);
        $('.addToCart, .addIndividualLink, .price__quantity-sign, .btn-packbuilder, .js-build-pack').attr('disabled', 'disabled');
    } else {
        $productError.remove();
        $productPrice.removeClass('is--disabled');
        $pricePromo.removeClass('d-none');
        resetDecrease();
    }
}

function resetDecrease() {
    if(getQuantity() > 1) {
        $('.price__quantity-sign.decrease-items').removeClass(IS_DISABLED);
    }
}

function getUpdatedQuantity() {
    if(updatedQuantity > 1) {
        $('.price__quantity-sign--amount').val(updatedQuantity);
    }
}

function getUpdatedQuantityKey() {
    let $this = $(this);
    updatedQuantity = $this.val();
}

function loadPaypalMessage() {
    let showPayIn4Verbiage = $('#hidden-show-payin4-msg').val();
    if(showPayIn4Verbiage && showPayIn4Verbiage === 'True') {
        let selectedPriceType = $('#hidden-selected-pricetype').val() || $('.form-input--radio:checked').attr('id');
        if(!window.braintree) {
            return;
        }
        braintree.client.create({
            authorization: selectedPriceType === 'PC-NewMemberRewards' ? $('#hidden-autoshipClientToken').val() : $('#hidden-clientToken').val()
        }, function (clientErr, clientInstance) {
            if(clientErr) {
                console.error('Error creating client:', clientErr);
                return;
            }
            braintree.paypalCheckout.create({
                autoSetDataUserIdToken: true,
                client: clientInstance
            }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                paypalCheckoutInstance.loadPayPalSDK({
                    components: 'messages'
                }, function () {
                });
            });
        });
    }
}

function setPriceType() {
    var $priceTypeLabel = $(this).closest('label');
    var flowTempUnavailable = { msg: '' };
    flowTempUnavailable.msg = $priceTypeLabel.parent().data('tempunavailablemsg');
    var priceType = $priceTypeLabel.data('facet-type');
    $('#hidden-selected-pricetype').val(priceType);
    let product = selectedKitProduct || selectedProduct;
    let unavailable = product.IsTempUnavailable || product.IsComingSoon;
    if(productData.IsIndividualLinkSession && !flowTempUnavailable.msg && !unavailable) {
        checkProductShareLink();
    }
    loadPaypalMessage();
    if(this.id !== 'tryonce') {
        // only check fo OoS if not tryonce element
        if(flowTempUnavailable.msg) {
            checkProductOos(flowTempUnavailable);
        } else {
            checkProductOos({ msg: '' });
        }
    }
    if(priceType) {
        try {
            updatedCheckedPriceType = priceType.replace(/ /g, '-');
        } catch (ex) {
            console.error(`Error replacing priceType: ${priceType}`, ex);
            if($priceTypeLabel && $priceTypeLabel.length) {
                console.error(`$priceTypeLabel: ${$priceTypeLabel[0].outerHTML}`);
            }
        }
        displayPackPrice(updatedCheckedPriceType);
        updateProductShareUrl(product.Id || product.ID);
    }
    populateStickyHeader($priceTypeLabel);
    updateQuantityToZeroIfUnavailable();
}

function toggleStickyHeader($selector) {
    const upgradedProductContainer = $($selector);
    const upgradedProductSectionContainer = upgradedProductContainer.find('.product__details .price__single-quantity-selector .price__group');
    if($(upgradedProductSectionContainer).length) {
        upgradedSectionOffSet = $(upgradedProductSectionContainer).offset().top;
    }
    const shouldDisplayStickyHeader = $(window).scrollTop() > (upgradedSectionOffSet);
    if($(upgradedProductContainer).length) {
        const originalSelector = upgradedProductContainer.find('.product__details .price__single-quantity-selector .price__group');
        const stickySelector = $('#product-price-sticky-header');

        if(shouldDisplayStickyHeader) {
            if(!originalSelector.hasClass('hide-section-styles')) {
                originalSelector.addClass('hide-section-styles');
            }
            if(stickySelector.hasClass('hide-section-styles')) {
                stickySelector.removeClass('hide-section-styles');
            }
        } else {
            if(!stickySelector.hasClass('hide-section-styles')) {
                stickySelector.addClass('hide-section-styles');
            }
            if(originalSelector.hasClass('hide-section-styles')) {
                originalSelector.removeClass('hide-section-styles');
            }
        }
    }
}

function populateStickyHeader($priceTypeLabel) {
    let packagingLabel;
    let packagingValue;
    let flavorLabel;
    let flavorValue;
    const pricePointLabel = $priceTypeLabel.find('.price__price-wrapper .form-text--label').text();
    const priceHtml = $priceTypeLabel.find('.product__price-section-right').html();

    const stickyHeader = $('#product-price-sticky-header');
    const parentNode = $(stickyHeader).closest('.product.upgraded-product');
    const productName = $(parentNode).find('.product__heading .product__header').text();
    let flavorPackagingNode = $(parentNode).find('.product__details .product__selected');

    if($(flavorPackagingNode).hasClass('product__selected--multi-facets')) {
        const flavorNode = $(flavorPackagingNode).find('.product__selector.filter-by .product__selected-text');
        flavorLabel = flavorNode.contents().filter(function () {
            return this.nodeType === 3;
        }).text().trim();
        flavorValue = flavorNode.find('span').text();

        const pacNode = $(flavorPackagingNode).find('.product__selector.filter .product__selected-text');
        packagingLabel = pacNode.contents().filter(function () {
            return this.nodeType === 3;
        }).text().trim();
        packagingValue = pacNode.find('span').text();
    } else {
        const flavorNode = $(flavorPackagingNode).find('.product__selector.filter-by .product__selected-text');
        flavorLabel = flavorNode.contents().filter(function () {
            return this.nodeType === 3;
        }).text().trim();
        flavorValue = flavorNode.find('span').text();
    }

    $(stickyHeader).find('.product_price-sticky-header-desktop .sticky-price-point-label').text(pricePointLabel);
    $(stickyHeader).find('.product_price-sticky-header-desktop .product_price-sticky-right-section .sticky-unit-price').html(priceHtml);
    $(stickyHeader).find('.product_price-sticky-header-desktop .sticky-product-name').text(productName);
    $(stickyHeader).find('.product_price-sticky-header-desktop .sticky-product-name').text(productName);
    if(flavorLabel && flavorValue) {
        let flavorNode = $(stickyHeader).find('.sticky-product-flavor');
        $(flavorNode).find('label').text(flavorLabel);
        $(flavorNode).find('span').text(flavorValue);
    }

    if(packagingLabel && packagingValue) {
        let packagingNode = $(stickyHeader).find('.sticky-product-packaging');
        $(packagingNode).find('label').text(packagingLabel);
        $(packagingNode).find('span').text(packagingValue);
    }

    const adjacentButton = $('#retailPackBuilderButtonSticky').siblings('.js-build-pack');
    if($('#retailPackBuilderButton').hasClass('d-none')) {
        $('#retailPackBuilderButtonSticky').hasClass('d-none');
        $(adjacentButton).removeClass('d-none');
    }

    if(!$('#retailPackBuilderButton').hasClass('d-none')) {
        $('#retailPackBuilderButtonSticky').removeClass('d-none');
        $(adjacentButton).addClass('d-none');
    }
}

function displayPackPrice(userType) {
    if(!userType) return;
    $('.pack-prices').hide();
    $(`.pack-prices[data-usertype="${userType}"]`).show();
}

function checkPriceType() {
    let $priceBlock = $('.price__block');
    if(updatedCheckedPriceType) {
        var priceTypeClass = updatedCheckedPriceType.replace(/ /g, '-');
        $(`.${priceTypeClass}`).find(`input:not(${TRY_ONCE})`).click();
    } else if(!$priceBlock.hasClass('.PC')) {
        $('.price__block:first').find('input').click();
    }
    updateQuantityToZeroIfUnavailable();
}

function sortPrice() {
    let $priceBlock = $('.price__block');
    $priceBlock.sort(function (a, b) {
        return +a.dataset.orderby - +b.dataset.orderby;
    }).appendTo('.price__selector');
}

function copyToClipboard() {
    let $productShareUrl = $('#productUrl');
    $productShareUrl.select();
    document.execCommand('copy');
}

function checkForHiddenPriceOptions(items) {
    const { HideSubscriptionOption, HidePCOption } = productData;

    const shouldHideTier = item => {
        if(HideSubscriptionOption && item.Tier === PC_NMR) {
            return true;
        }
        if(HidePCOption && item.Tier === PC_NM) {
            return true;
        }
        return false;
    };

    return items.filter(item => !shouldHideTier(item));
}

function displaySelectedProduct(productId) {
    let productList = productData.Products;
    let productLabel = productData.Labels;
    let cartPageUrl = productData.ProductDetailsViewModalModel.CartPageUrl;
    let kits = productData.Kits;
    let $productKit = $('.product__kit');
    let productDisclaimers;
    if(productData.Disclaimers) {
        productDisclaimers = productData.Disclaimers;
    }
    let product = productList.find(({ ID }) => ID == productId); // eslint-disable-line
    let qty = 1;
    // if kits as product is enabled
    if(kits) {
        selectedKitProduct = kits.find(({ Id }) => Id == productId); // eslint-disable-line
        if(selectedKitProduct) {
            if(productData.EditProduct) {
                if(productData.EditProduct.ProductId === selectedKitProduct.Id) {
                    qty = productData.EditProduct.Quantity;
                }
            }

            let retailGuestPrice = null;

            if(selectedKitProduct.PackPrices) {
                let priceTier = selectedKitProduct.PackPrices.find(entry => entry.Tier === RETAIL_CHECKOUT);
                if(priceTier !== undefined) { retailGuestPrice = priceTier.DisplayPrice; }
            }

            let updatedPackPricesArray = checkForHiddenPriceOptions(selectedKitProduct.PackPrices);
            if(updatedPackPricesArray) {
                selectedKitProduct.PackPrices = updatedPackPricesArray;
            }

            let mergedData = {
                productLabel,
                productDisclaimers,
                selectedKitProduct,
                cartPageUrl,
                IsAuthenticatedUser: isAuthenticatedUser,
                DisplayBV: displayBV,
                IsNotAmbassador: isNotAmbassador,
                IsBrandPartnerIFrame: productData.IsBrandPartnerIFrame,
                IsBrandPartnerCustomer: productData.IsBrandPartnerCustomer,
                DisplayTryOnce: productData.DisplayTryOnce,
                HideTryOnce: productData.HideTryOnce,
                Quantity: qty,
                IsUpgradedPDP: productData.IsUpgradedPDP,
                IsTaxInclusive: productData.IsTaxInclusive,
                ShowPayPalPayIn4Verbiage: productData.ShowPayPalPayIn4Verbiage,
                DisableAddToCartButton: productData.DisableAddToCartButton,
                RetailGuestPrice: retailGuestPrice,
                HideAddToCartForEUNFRCuntries: productData.HideAddToCartForEUNFRCuntries,
                IsComingSoon: productData.IsComingSoon,
                IsBundleLinkSession: productData.IsBundleLinkSession,
                IsIndividualLinkSession: productData.IsIndividualLinkSession,
                HasCopyShareLink: createLinkList.some(p => p.ProductSku === selectedKitProduct.Sku)
            };

            let productGalleryUpdateHtml = productGalleryUpdate(selectedKitProduct.Assets);
            $productGallery.html(productGalleryUpdateHtml);
            let productPriceUpdateHtml = productKitAsProductPrice(mergedData);
            selectedKitProduct = { ...selectedKitProduct, IsUpgradedPDP: productData.IsUpgradedPDP, ContentsLabel: productData.ContentsLabel };
            $productPriceDetail.html(productPriceUpdateHtml);

            if(productData.IsUpgradedPDP) {
                const mdata = { ...mergedData, selectedProduct: selectedKitProduct };
                let stickyHeaderHtml = productPriceStickyHeader(mdata);
                $productPriceStickyHeaderSection.html(stickyHeaderHtml);
            }
            if(selectedKitProduct.PackGroups) {
                let productKitHtml = productBiomeKitDetails(selectedKitProduct);
                $productKit.html(productKitHtml);
            }
            if(selectedKitProduct.Description) {
                let productDescriptionUpdateHtml = productDescriptionUpdate(selectedKitProduct);
                $productDetailsDescription.html(productDescriptionUpdateHtml);
            } else {
                let productDescriptionHtml = productDescription(productData);
                $productDetailsDescription.html(productDescriptionHtml);
            }

            triggerUpdateDescriptionEvent();
            if(productData.IsUpgradedPDP) {
                displayThumbnailSection(selectedKitProduct);
            }

            // checkHeight();
            checkStatus(selectedKitProduct);
            checkProductOos();
            sortPrice();
            let productInfo = new CustomEvent('product', { // eslint-disable-line
                detail: {
                    selectedProduct: selectedKitProduct
                }
            });

            displayBadges();
            loadSubHeader();
            selectedProduct = undefined;
            window.dispatchEvent(productInfo);
            checkCustomerType();
            postMessage(selectedKitProduct);
            return;
        }
    }

    if(!selectedKitProduct && product) {
        selectedProduct = product;
    } else {
        // remove pid from url
        replaceQueryString(PRODUCTID_QS, null);
    }

    if(selectedProduct) {
        if(productData.EditProduct) {
            if(productData.EditProduct.ProductId === selectedProduct.ID) {
                qty = productData.EditProduct.Quantity;
            }
        }
        selectedKitProduct = null;
        let retailGuestPrice = null;

        if(selectedProduct.PricesAndBV) {
            let priceTier = selectedProduct.PricesAndBV.find(entry => entry.Tier === RETAIL_CHECKOUT);
            if(priceTier !== undefined) { retailGuestPrice = priceTier.DisplayPrice; }
        }

        // Check for price options that are set to be hidden via Sitecore and update the PricesAndBV array
        let updatedPricesAndBVArray = checkForHiddenPriceOptions(selectedProduct.PricesAndBV);
        if(updatedPricesAndBVArray) {
            selectedProduct.PricesAndBV = updatedPricesAndBVArray;
        }

        let mergedData2 = {
            productLabel,
            productDisclaimers,
            selectedProduct,
            cartPageUrl,
            IsAuthenticatedUser: isAuthenticatedUser,
            DisplayBV: displayBV,
            IsNotAmbassador: isNotAmbassador,
            IsBrandPartnerIFrame: productData.IsBrandPartnerIFrame,
            IsBrandPartnerCustomer: productData.IsBrandPartnerCustomer,
            DisplayTryOnce: productData.DisplayTryOnce,
            HideTryOnce: productData.HideTryOnce,
            Quantity: qty,
            IsUpgradedPDP: productData.IsUpgradedPDP,
            IsTaxInclusive: productData.IsTaxInclusive,
            ShowPayPalPayIn4Verbiage: productData.ShowPayPalPayIn4Verbiage,
            RetailGuestPrice: retailGuestPrice,
            DisableAddToCartButton: productData.DisableAddToCartButton,
            HideAddToCartForEUNFRCuntries: productData.HideAddToCartForEUNFRCuntries,
            IsComingSoon: productData.IsComingSoon,
            IsBundleLinkSession: productData.IsBundleLinkSession,
            IsIndividualLinkSession: productData.IsIndividualLinkSession,
            HasCopyShareLink: createLinkList.some(p => p.ProductSku === selectedProduct.Sku)
        };

        if($productKit.length) {
            if(productData.BundleConfiguration &&
                selectedProduct.ID === productData.BundleConfiguration.Id &&
                !productData.BundleConfiguration.IsConfigurable) {
                let bundleConfig = { ...productData.BundleConfiguration, IsUpgradedPDP: productData.IsUpgradedPDP, ContentsLabel: productData.ContentsLabel };
                let productKitContentTmpl = productKitContents(bundleConfig);
                $productKit.html(productKitContentTmpl);
            } else {
                $productKit.html('');
            }
        }

        let productGalleryUpdateHtml = productGalleryUpdate(selectedProduct.Assets);
        $productGallery.html(productGalleryUpdateHtml);
        let productPriceUpdateHtml2 = productPriceUpdate(mergedData2);
        $productPriceDetail.html(productPriceUpdateHtml2);
        if(mergedData2.IsUpgradedPDP) {
            let stickyHeaderHtml = productPriceStickyHeader(mergedData2);
            $productPriceStickyHeaderSection.html(stickyHeaderHtml);
            displayThumbnailSection(selectedProduct);
        }

        let productInfo = new CustomEvent('product', { // eslint-disable-line
            detail: {
                selectedProduct
            }
        });
        window.dispatchEvent(productInfo);
        // check for unique product description
        if(selectedProduct.Description) {
            let productDescriptionUpdateHtml = productDescriptionUpdate(selectedProduct);
            $productDetailsDescription.html(productDescriptionUpdateHtml);
        } else {
            let productDescriptionHtml = productDescription(productData);
            $productDetailsDescription.html(productDescriptionHtml);
        }

        triggerUpdateDescriptionEvent();

        displayBadges();
        // checkHeight();
        $(`label.${productId} input[type="radio"]`).prop('checked', true);
        // unavailable
        checkStatus();
        checkProductOos();
        postMessage(selectedProduct);
        loadSubHeader();
    }
}

function triggerUpdateDescriptionEvent() {
    if(productData.IsUpgradedPDP) {
        let productdescriptionReadMoreButton = $('#product__details-read-more-btn');
        if(productdescriptionReadMoreButton.length) {
            let productDescriptionSection = $('.upgraded-product .product__details .product__details-description');
            if(productDescriptionSection.length) {
                $(productDescriptionSection).trigger('descriptionChange');
            }
        }
    }
}

function loadPartials() {
    let productGalleryHtml = productGallery(productData);
    let products = productData.Products;
    let productFamily = productData.ProductFamily;
    let groupByFacets = productFamily[0].GroupByFacets;

    if(groupByFacets.length === 0 && (!productData.Kits || productData.Kits.length < 1)) {
        productData.Products.forEach(function (item, index, object) {
            if(item.ID === selectedProduct.ID) {
                Object.keys(object).forEach(function (prod) {
                    let prodNumber = parseInt(prod, 10);
                    if(prodNumber !== index) {
                        object.splice(index, 1);
                    }
                });

                let updatedGallery = productGallery(productData);
                renderPrice();
                $productGallery.html(updatedGallery);
            }
        });
    } else {
        renderPrice();
        $productGallery.html(productGalleryHtml);
    }

    let productDescriptions = products.find(function (item) {
        return item.Description;
    });
    if(productDescriptions) {
        let productDescriptionUpdateHtml = productDescriptionUpdate(selectedProduct);
        $productDetailsDescription.html(productDescriptionUpdateHtml);
    } else {
        let productDescriptionHtml = productDescription(productData);
        $productDetailsDescription.html(productDescriptionHtml);
    }

    if(productData.IsUpgradedPDP) {
        if(selectedProduct) {
            displayThumbnailSection(selectedProduct);
        } else {
            if(productData.Kits && productData.Kits.length > 0) {
                displayThumbnailSection(productData.Kits[0]);
            }
        }
    }

    triggerUpdateDescriptionEvent();
    // checkHeight();
}

function displayThumbnailSection(productRelatedData) {
    const noOfThumbnails = parseInt($('.product.upgraded-product').data('no-of-thumbnails')) || 6;
    const thumbnails = productRelatedData.Assets.slice(0, noOfThumbnails);
    for (const element of thumbnails) {
        element.IsVideo = element.AssetType === 'Video';
    }
    const productImageThumbnails = { Thumbnails: thumbnails };
    let productGalleryThumbnailSectionHtml = productGalleryThumbnail(productImageThumbnails);
    $productGalleryThumbnailSection.html(productGalleryThumbnailSectionHtml);
}

function checkCustomerType() {
    let customerType = productData.CustomerType;
    if(!customerType) return;
    let $priceBlock = $('.price__block');
    $priceBlock.each(function () {
        let $this = $(this);
        if(!$this.hasClass(customerType)) {
            $this.remove();
        }
    });
}

function loadTooltip() {
    setTimeout(() => {
        let $dataToggleTooltip = $('[data-toggle="tooltip"]');
        if($dataToggleTooltip.length) {
            $dataToggleTooltip.tooltip();
        }
    }, 300);
}

function getKitsStockCheck() {
    let kitIdList = [];
    let keys = {};
    if(productData && productData.Kits) {
        productData.Kits.forEach(function (kit) {
            if(kit.IsCheckStock) {
                kitIdList.push({ ID: kit.Id, IsCheckStock: true });
                keys[kit.Id] = true;
                return;
            }
            if(kit.PackGroups) {
                kit.PackGroups.forEach(function (packGroup) {
                    if(packGroup.Products) {
                        let checkStockFlag = packGroup.Products.some(i => i.IsCheckStock);
                        if(checkStockFlag && !keys[kit.Id]) {
                            kitIdList.push({ ID: kit.Id, IsCheckStock: true });
                            keys[kit.Id] = true;
                        }
                    }
                });
            }
        });
    }
    return kitIdList;
}

async function checkStock() {
    let productList = null;

    if(productData !== null && productData !== undefined) {
        productList = productData.Products;
    }
    let kitProductList = getKitsStockCheck();
    if(kitProductList.length > 0) {
        productList = productList || [];
        productList = productList.concat(kitProductList);
    }
    if(!productList || productList.length < 1) return;

    let idsToCheck = productList.filter(i => i.IsCheckStock).map(i => i.ID);
    if(!idsToCheck || idsToCheck.length < 1) return;

    var response = await inventoryService.getUnavailableInventory(idsToCheck);
    if(response && response.length > 0) {
        outOfStockProductIds = response;
        checkProductOos();
    }
}

function createGroupByFacets() {
    let $productFilters = $('.product__selected');
    if(!productData.ProductFamily) return;

    let productFamily = productData.ProductFamily;
    productFamily.forEach(function (item) {
        let groupBy = item.GroupByFacets;
        // create group by facet containers
        let groupByHtml = productFilters(groupBy);
        $productFilters.html(groupByHtml);
        // secondary facets
        secondaryFacets = item.SecondaryFacetGroupId;
        // check for facet with images
        let facetDefinitions = productData.FacetDefinitions;
        let facetImage = facetDefinitions.filter(function (facetDefinition) {
            return facetDefinition.Image;
        });
        let facetRadioButtons = facetDefinitions.filter(function (facetRadioButton) {
            return !facetRadioButton.Image;
        });

        if(secondaryFacets) {
            let filterImg = facetImage.filter(function (img) {
                let filterBy = img.FacetGroupId;
                return filterBy !== secondaryFacets;
            });

            let validFilterImg = FilterFacetImgByProduct(filterImg, groupBy);
            let filterHtml = productImageBtn(validFilterImg);
            let mobileImgHtml = productMobileList(filterImg);
            $productFilters.append(filterHtml);
            $productFilters.append(mobileImgHtml);
            let secondaryFacet = facetDefinitions.filter(function (item) {
                return item.FacetGroupId === secondaryFacets;
            });
            let productFacetsHtml = productFacets(secondaryFacet);
            $productDietaryRestrictions.append(productFacetsHtml);
        } else if(facetImage) {
            let filterHtml = productImageBtn(facetImage);
            let mobileImgHtml = productMobileList(facetImage);
            $productFilters.append(filterHtml);
            $productFilters.append(mobileImgHtml);
        }

        if(facetRadioButtons) {
            let filterBtn = facetRadioButtons.filter(function (filterby) {
                let filterSecondary = filterby.FacetGroupId;
                return filterSecondary !== secondaryFacets;
            });
            let defaultHtml = productRadioBtn(filterBtn);
            let mobileDefaultHtml = productMobileList(filterBtn);
            $productFilters.append(defaultHtml);
            $productFilters.append(mobileDefaultHtml);
            $('.product__selected > label, .product__selected > li').each(function () {
                let $this = $(this);
                let facetType = $this.data('facet-type');
                let facetId = $this.data('id');
                $(`#${facetType}.product__select`).append($this);
                $(`[data-product-id="${facetId}"].product__mobile-list`).append($this);
            });
            $('.product__mobile-list li').each(function () {
                let $this = $(this);
                let productID = $this.parent('ul').data('product-id');
                let facetMatch = $this.data('id');
                if(facetMatch !== productID) {
                    $this.remove();
                }
            });
            $('.product__selected > label, .product__selected > li').remove();
        }

        if(groupBy &&
            ((productData.Products && productData.Products.length > 0) ||
                (productData.Kits && productData.Kits.length > 0))) {
            let facetCount = Object.keys(groupBy).length;
            if(facetCount === 1) {
                $productFilters.addClass('product__selected--single-facet');
                singleFacet = $('product__selected--single-facet');
                loadPartials();
            } else if(groupBy.length === 0) {
                // no facets
                $productFilters.addClass('product__selected--no-facets');
                loadPartials();
                checkProductOos();
            } else {
                $productFilters.addClass('product__selected--multi-facets');
                multiFacets = $('product__selected--multi-facets');
            }
        }
    });
}

function FilterFacetImgByProduct(filterImg) {
    let validFilterImg = filterImg;
    let products = productData.Products;
    if(filterImg.length === 0 || filterImg.length === products.length) {
        return filterImg;
    }

    validFilterImg = filterImg.filter(function (img) {
        let matchingFacets;
        products.forEach(function (product) {
            product.Facets.forEach(function (facet) {
                if(facet.FacetValueId === img.FacetValueId) {
                    matchingFacets = facet.FacetValueId;
                }
            });
        });
        return img.FacetValueId === matchingFacets;
    });
    return validFilterImg;
}

function checkNullPrices() {
    if(!productData || !productData.Products) return;

    let productList = productData.Products;
    let prices = productList.filter(function (price) {
        let priceCheck = price.PricesAndBV;
        return priceCheck.length;
    });
    prices.forEach(function (item) {
        facets = item.Facets;
        assets = item.Assets;
        tier = item.PricesAndBV;
        productId = item.ID;
        let facetId;
        let productFilter = facets.concat(tier, assets);
        productFilter.filter(function (item) {
            facetId = item.FacetValueId;
            $(`[data-facet-value=${facetId}],[data-facet-type=${facetId}]`).addClass(productId);
        });
    });
}

function checkForProducts() {
    let $productFilters = $('.product__selected');
    let kits = productData.Kits;
    if(kits) {
        $productFilters.removeClass(IS_HIDDEN);
    } else if(!productData.Products || !productData.Products.length) {
        $productFilters.addClass(IS_HIDDEN);
        let productDescriptionHtml = productDescription(productData);
        $productDetailsDescription.html(productDescriptionHtml);
        triggerUpdateDescriptionEvent();
    }
}

function checkKits() {
    // biome kits and products
    let kits = productData.Kits;
    if(!kits) return;

    // check for RenderAsRegularProduct for kit layout
    kits.forEach(function (item) {
        checkRender = item.RenderAsRegularProduct;
    });
    if(checkRender) {
        $('.product__related-groups').remove();
        let prices = kits.filter(function (item) {
            let priceCheck = item.PackPrices;
            return priceCheck.length;
        });
        prices.forEach(function (item) {
            facets = item.Facets;
            assets = item.Assets;
            tier = item.PackPrices;
            productId = item.Id;
            let facetId;
            let productFilter = facets.concat(tier, assets);
            productFilter.filter(function (items) {
                facetId = items.FacetValueId;
                $(`[data-facet-value=${facetId}],[data-facet-type=${facetId}]`).addClass(productId);
            });
        });
    } else {
        let productKitsHtml = productBiomeKits(productData.Kits);
        $('.product__related-group-list').append(productKitsHtml);
        $('.product__selected').addClass(IS_HIDDEN);
    }

    // if products exist with kits
    if(productData.Products) {
        let productsHtml = productBiomeProducts(productData.Products);
        $('.product__related-group-list').append(productsHtml);
    }

    $('.product__related-group-list input').on('click', function () {
        let $this = $(this);
        let productID = $this.attr('id');
        let productLabels = productData.Labels;
        let facetId;
        let qty = 1;
        if($this.hasClass('is--kit')) {
            let productKitFilter = productData.Kits;
            let kitDetails = productKitFilter.find(({ Id }) => Id === productID);
            let productDisclaimers;
            selectedProduct = kitDetails;
            if(productData.Disclaimers) {
                productDisclaimers = productData.Disclaimers;
            }
            if(productData.EditProduct) {
                if(selectedProduct && productData.EditProduct.ProductId === selectedProduct.ID) {
                    qty = productData.EditProduct.Quantity;
                }
            }
            let mergedData = {
                kitDetails,
                productLabels,
                productDisclaimers,
                IsAuthenticatedUser: isAuthenticatedUser,
                DisplayBV: displayBV,
                IsNotAmbassador: isNotAmbassador,
                IsBrandPartnerIFrame: productData.IsBrandPartnerIFrame,
                IsBrandPartnerCustomer: productData.IsBrandPartnerCustomer,
                DisplayTryOnce: productData.DisplayTryOnce,
                HideTryOnce: productData.HideTryOnce,
                Quantity: qty,
                IsUpgradedPDP: productData.IsUpgradedPDP,
                IsTaxInclusive: productData.IsTaxInclusive,
                ShowPayPalPayIn4Verbiage: productData.ShowPayPalPayIn4Verbiage,
                DisableAddToCartButton: productData.DisableAddToCartButton,
                HideAddToCartForEUNFRCuntries: productData.HideAddToCartForEUNFRCuntries,
                IsComingSoon: productData.IsComingSoon,
                IsBundleLinkSession: productData.IsBundleLinkSession,
                IsIndividualLinkSession: productData.IsIndividualLinkSession,
                HasCopyShareLink: createLinkList.some(p => p.ProductSku === kitDetails.Sku)
            };

            let productGalleryUpdateHtml = productGalleryUpdate(kitDetails.Assets);
            $productGallery.html(productGalleryUpdateHtml);
            let productPriceUpdateHtml = productBiomeKitPrice(mergedData);
            $productPriceDetail.html(productPriceUpdateHtml);
            kitDetails = { ...kitDetails, IsUpgradedPDP: productData.IsUpgradedPDP, ContentsLabel: productData.ContentsLabel };
            let productKitHtml = productBiomeKitDetails(kitDetails);
            $productKit.html(productKitHtml);
            if(kitDetails.IsUpgradedPDP) {
                displayThumbnailSection(kitDetails);
            }
            if(secondaryFacets) {
                let kitFacets = kitDetails.Facets;
                let kitId = kitDetails.Id;
                let kitSecondaryFacets = kitFacets.filter(function (item) {
                    return item.FacetGroupId === secondaryFacets;
                });
                kitSecondaryFacets.filter(function (item) {
                    facetId = item.FacetValueId;
                    $(`[data-facet-value=${facetId}],[data-facet-type=${facetId}]`).addClass(kitId);
                });
            }
        } else {
            let productFilter = productData.Products;
            let productDetails = productFilter.find(({ ID }) => ID === productID);
            let productDisclaimers;
            selectedKitProduct = null;
            selectedProduct = productDetails;
            if(productData.Disclaimers) {
                productDisclaimers = productData.Disclaimers;
            }
            if(productData.EditProduct) {
                if(selectedProduct && productData.EditProduct.ProductId === selectedProduct.ID) {
                    qty = productData.EditProduct.Quantity;
                }
            }
            let mergedData = {
                productDetails,
                productLabels,
                productDisclaimers,
                IsAuthenticatedUser: isAuthenticatedUser,
                DisplayBV: displayBV,
                IsNotAmbassador: isNotAmbassador,
                IsBrandPartnerIFrame: productData.IsBrandPartnerIFrame,
                IsBrandPartnerCustomer: productData.IsBrandPartnerCustomer,
                DisplayTryOnce: productData.DisplayTryOnce,
                HideTryOnce: productData.HideTryOnce,
                Quantity: qty,
                IsUpgradedPDP: productData.IsUpgradedPDP,
                IsTaxInclusive: productData.IsTaxInclusive,
                ShowPayPalPayIn4Verbiage: productData.ShowPayPalPayIn4Verbiage,
                DisableAddToCartButton: productData.DisableAddToCartButton,
                HideAddToCartForEUNFRCuntries: productData.HideAddToCartForEUNFRCuntries,
                IsComingSoon: productData.IsComingSoon,
                IsBundleLinkSession: productData.IsBundleLinkSession,
                IsIndividualLinkSession: productData.IsIndividualLinkSession,
                HasCopyShareLink: createLinkList.some(p => p.ProductSku === productDetails.Sku)
            };

            let productGalleryUpdateHtml = productGalleryUpdate(productDetails.Assets);
            $productGallery.html(productGalleryUpdateHtml);
            let productPriceUpdateHtml = productBiomeProductPrice(mergedData);
            $productPriceDetail.html(productPriceUpdateHtml);
            $productKit.html('');
            if(productData.IsUpgradedPDP) {
                displayThumbnailSection(productDetails);
            }
            if(secondaryFacets) {
                let productKitFacets = productDetails.Facets;
                let productKitId = productDetails.ID;
                let productSecondaryFacets = productKitFacets.filter(function (item) {
                    return item.FacetGroupId === secondaryFacets;
                });
                productSecondaryFacets.filter(function (item) {
                    facetId = item.FacetValueId;
                    $(`[data-facet-value=${facetId}],[data-facet-type=${facetId}]`).addClass(productKitId);
                });
            }
        }
        loadTooltip();
        checkCustomerType();
        sortPrice();
        showEditProductCTA();
        checkStatus();
        updateProductShareUrl(productID);
        if($addToCartType) {
            $addToCartType.remove();
        }
        $('.product__dietary-restrictions-item').hide();
        if(productID) {
            $(`.product__dietary-restrictions-item.${productID}`).show();
        }
    });
}

function renderPrice() {
    if(!productData.BundleConfiguration) {
        let productPriceHtml = productPrice(productData);
        $productPriceDetail.html(productPriceHtml);
    } else {
        // product kit
        let retailGuestPrice = null;
        let updatedProductData = null;

        if(selectedProduct.PricesAndBV) {
            let priceTier = selectedProduct.PricesAndBV.find(entry => entry.Tier === RETAIL_CHECKOUT);
            if(priceTier !== undefined) {
                retailGuestPrice = priceTier.DisplayPrice;
                updatedProductData = { ...productData, RetailGuestPrice: retailGuestPrice };
            } else {
                updatedProductData = productData;
            }
        }

        let updatedPricesAndBVArray = checkForHiddenPriceOptions(selectedProduct.PricesAndBV);
        if(updatedPricesAndBVArray) {
            updatedProductData.Products[0].PricesAndBV = updatedPricesAndBVArray;
        }
        updatedProductData = {...updatedProductData, HasCopyShareLink: createLinkList.some(p => p.ProductSku === selectedProduct.Sku)};
        if(!productData.BundleConfiguration.IsConfigurable) {
            let productKitHtml = productKit(productData);
            let productPriceHtml = productPriceKit(updatedProductData);
            $productPriceDetail.html(productPriceHtml);
            $productKit.append(productKitHtml);
            if(updatedProductData.IsUpgradedPDP) {
                let stickyHeaderHtml = productKitStickyHeader(updatedProductData);
                $productPriceStickyHeaderSection.html(stickyHeaderHtml);
            }
        } else {
            let singlePack = updatedProductData.Products[0];
            if(singlePack) {
                let isUnavailableAnyway = singlePack.IsCheckStockAndZeroQuantity || singlePack.IsTemporaryUnavailableOrHasTemporaryUnavailableMessageCode;
                updatedProductData = {...updatedProductData, IsUnavailableAnyway: isUnavailableAnyway};
            }
            let productPricePackHtml = productPricePack(updatedProductData);
            $productPriceDetail.html(productPricePackHtml);
            sortPrice();
            if(updatedProductData.IsUpgradedPDP) {
                let stickyHeaderHtml = productPackStickyHeader(updatedProductData);
                $productPriceStickyHeaderSection.html(stickyHeaderHtml);
            }
        }
    }
}

function updateProductShareUrl(pid) {
    let $productShareUrl = $('#productUrl');

    if(pid) {
        replaceQueryString(PRODUCTID_QS, pid);
    }

    if($productShareUrl.length < 1) return;
    $productShareUrl.val(window.location.href);
}

function sortFacets() {
    let $productSelector = $('.product__selector');
    let $facets = $('.product__select:first label');

    $productSelector.sort(function (a, b) {
        return +a.dataset.orderby - +b.dataset.orderby;
    }).appendTo('.product__selected');

    $facets.sort(function (a, b) {
        return +a.dataset.orderby - +b.dataset.orderby;
    }).appendTo('.product__select:first');
}

function updateQuantityToZeroIfUnavailable() {
    const $input = $('input[type="number"].price__quantity-sign');
    if($input.length && $input.prop('disabled')) {
        $input.val(0);
    }
}

function checkMultiFacets() {
    let $productSelector = $('.product__selector');
    if(multiFacets) {
        $productSelector.first().addClass(`${FILTER_BY}`);
        $productSelector.last().addClass(`${FILTER}`);
    } else {
        $productSelector.first().addClass(`${FILTER_BY}`);
    }

    if(multiFacets) {
        $(`.${FILTER_BY} .${PRODUCT_LABEL}`).on('click', function () {
            let $this = $(this);
            let mobileType = $this.parent('label').data('facet-type');
            let mobileName = $this.parent('label').data('label-name');
            $(`.product__mobile-toggle[data-toggle-id="${mobileType}"] .product__mobile-selected`).text(mobileName);
            var labelClass = $this.parents(DATA_FILTERBY).attr('class');
            if(labelClass) {
                filtering = $this.parents(DATA_FILTERBY).attr('class').split(' ');
            }
            $(`.${FILTER} ${DATA_FILTERBY}, .${FILTER} .product__mobile-list li`).addClass('d-none');
            $.each(filtering, function () {
                $(`.${FILTER} ${DATA_FILTERBY}.` + this).removeClass('d-none');
                $(`.${FILTER} .product__mobile-list li.` + this).removeClass('d-none');
            });

            if(productData.IsUpgradedPDP && $(window).width() < 768) {
                disableDropdownIfSingleItem(FILTER);
                $(`.${FILTER}`).find('label:first').find('input').click();
            } else {
                $(`.${FILTER}`).find('label:visible:first').find('input').click();
            }
        });

        $(`.${FILTER} .${PRODUCT_LABEL}`).on('click', $filterInput, function () {
            let $this = $(this);
            let mobileType = $this.parent('label').data('facet-type');
            let mobileName = $this.parent('label').data('label-name');
            $(`.product__mobile-toggle[data-toggle-id="${mobileType}"] .product__mobile-selected`).text(mobileName);
            filterFacetId = $this.parents(DATA_FILTERBY).attr('class').split(' ');
            $(`.product__mobile-list li, .product__selector.filter`).removeClass(IS_DISABLED_MOBILE);
            if(filtering) {
                let pdpFilter = filtering.filter(function (item) {
                    return filterFacetId.includes(item);
                })[0];
                $(`.product__dietary-restrictions-item`).addClass('d-none');
                $(`.product__dietary-restrictions-item.${pdpFilter}`).removeClass('d-none');
                displaySelectedProduct(pdpFilter);
                updateProductShareUrl(pdpFilter);
                let mobileOos = outOfStockProductIds.find(element => element == pdpFilter); // eslint-disable-line
                $(`.product__mobile-list li.${mobileOos}`).addClass(IS_DISABLED_MOBILE);
                $(`.product__mobile-list li.${mobileOos}`).parents(`.${FILTER}`).addClass(IS_DISABLED_MOBILE);
            }
            checkCustomerType();
            loadTooltip();
            sortPrice();
            showEditProductCTA();
            if($addToCartType) {
                $addToCartType.remove();
            }
            displayBadges();
        });
    } else if(singleFacet) {
        $(`.${FILTER_BY} .${PRODUCT_LABEL}`).on('click', function () {
            let $this = $(this);
            let mobileType = $this.parent('label').data('facet-type');
            let mobileName = $this.parent('label').data('label-name');
            $(`.product__mobile-toggle[data-toggle-id="${mobileType}"] .product__mobile-selected`).text(mobileName);
            filtering = $this.parents(DATA_FILTERBY).attr('class').split(' ');
            $(`.product__mobile-list li, .product__selector.filter-by`).removeClass(IS_DISABLED_MOBILE);
            let firstProduct = filtering[0];
            let productList = productData.Products;
            let productLabel = productData.Labels;
            let cartPageUrl = productData.ProductDetailsViewModalModel.CartPageUrl;
            selectedProduct = productList.find(({ ID }) => ID === firstProduct);
            let mobileOos = outOfStockProductIds.find(element => element == firstProduct); // eslint-disable-line
            if(checkRender) {
                displaySelectedProduct(firstProduct);
            }

            if(mobileOos) {
                $(`.product__mobile-list li.${mobileOos}`).addClass(IS_DISABLED_MOBILE);
                $(`.product__mobile-list li.${mobileOos}`).parents(`.${FILTER_BY}`).addClass(IS_DISABLED_MOBILE);
            }
            let qty = 1;
            if(selectedProduct) {
                if(productData.EditProduct) {
                    if(productData.EditProduct.ProductId === selectedProduct.ID) {
                        qty = productData.EditProduct.Quantity;
                    }
                }
                let productDisclaimers;
                if(productData.Disclaimers) {
                    productDisclaimers = productData.Disclaimers;
                }

                let retailGuestPrice = null;

                if(selectedProduct.PricesAndBV) {
                    let priceTier = selectedProduct.PricesAndBV.find(entry => entry.Tier === RETAIL_CHECKOUT);
                    if(priceTier !== undefined) { retailGuestPrice = priceTier.DisplayPrice; }
                }

                let updatedPricesAndBVArray = checkForHiddenPriceOptions(selectedProduct.PricesAndBV);
                if(updatedPricesAndBVArray) {
                    selectedProduct.PricesAndBV = updatedPricesAndBVArray;
                }

                let mergedData = {
                    productLabel,
                    selectedProduct,
                    productDisclaimers,
                    cartPageUrl,
                    IsAuthenticatedUser: isAuthenticatedUser,
                    DisplayBV: displayBV,
                    IsNotAmbassador: isNotAmbassador,
                    IsBrandPartnerIFrame: productData.IsBrandPartnerIFrame,
                    IsBrandPartnerCustomer: productData.IsBrandPartnerCustomer,
                    DisplayTryOnce: productData.DisplayTryOnce,
                    HideTryOnce: productData.HideTryOnce,
                    Quantity: qty,
                    IsUpgradedPDP: productData.IsUpgradedPDP,
                    IsTaxInclusive: productData.IsTaxInclusive,
                    ShowPayPalPayIn4Verbiage: productData.ShowPayPalPayIn4Verbiage,
                    DisableAddToCartButton: productData.DisableAddToCartButton,
                    RetailGuestPrice: retailGuestPrice,
                    HideAddToCartForEUNFRCuntries: productData.HideAddToCartForEUNFRCuntries,
                    IsComingSoon: productData.IsComingSoon,
                    IsBundleLinkSession: productData.IsBundleLinkSession,
                    IsIndividualLinkSession: productData.IsIndividualLinkSession,
                    HasCopyShareLink: createLinkList.some(p => p.ProductSku === selectedProduct.Sku)
                };
                let productGalleryUpdateHtml = productGalleryUpdate(selectedProduct.Assets);
                $productGallery.html(productGalleryUpdateHtml);
                let productPriceUpdateHtml = productPriceUpdate(mergedData);
                $productPriceDetail.html(productPriceUpdateHtml);
                if(productData.IsUpgradedPDP) {
                    let stickyHeaderHtml = productPriceStickyHeader(mergedData);
                    $productPriceStickyHeaderSection.html(stickyHeaderHtml);
                    displayThumbnailSection(selectedProduct);
                }
                $(`.product__dietary-restrictions-item`).addClass('d-none');
                $(`.product__dietary-restrictions-item.${firstProduct}`).removeClass('d-none');
                // update facets
                if(selectedProduct.Description) {
                    let productDescriptionUpdateHtml = productDescriptionUpdate(selectedProduct);
                    $productDetailsDescription.html(productDescriptionUpdateHtml);
                } else {
                    let productDescriptionHtml = productDescription(productData);
                    $productDetailsDescription.html(productDescriptionHtml);
                }
                triggerUpdateDescriptionEvent();
                checkCustomerType();
                loadTooltip();
                checkStatus();
                postMessage(selectedProduct);
                loadSubHeader();
                checkProductOos();
                // checkHeight();
                sortPrice();
                showEditProductCTA();
                if($addToCartType) {
                    $addToCartType.remove();
                }
            }
            displayBadges();
        });
    }

    if(!multiFacets && !singleFacet) {
        displayBadges();
    }

    disableDropdownIfSingleItem(FILTER_BY);
    disableDropdownIfSingleItem(FILTER);
}

function disableDropdownIfSingleItem(parentClassName) {
    if(productData.IsUpgradedPDP) {
        let liCount = $(`.upgraded-product .product__selector.${parentClassName} ul.product__mobile-list li:not(.d-none)`).length;
        if($(window).width() < 768) {
            const mobileToggleElement = $(`.upgraded-product .product__selector.${parentClassName} .product__mobile-toggle`);
            if(liCount === 1) {
                if(!$(mobileToggleElement).hasClass('d-none')) {
                    $(mobileToggleElement).addClass('d-none');
                }

                if(parentClassName === 'filter-by') {
                    const element = $(`.upgraded-product .product__selector.${parentClassName}`).closest('.product__selected.product__selected--multi-facets');
                    if(!$(element).hasClass('product__selected-no-flavor')) {
                        $(element).addClass('product__selected-no-flavor');
                    }
                }
            }

            if(liCount > 1) {
                if($(mobileToggleElement).hasClass('d-none')) {
                    $(mobileToggleElement).removeClass('d-none');
                }
            }
        } else {
            if(parentClassName === 'filter-by') {
                const productSelector = $(`.upgraded-product .product__selector.${parentClassName}`);
                const multiFacetParent = $(productSelector).closest('.product__selected.product__selected--multi-facets');
                if($(multiFacetParent).hasClass('product__selected-no-flavor')) {
                    $(multiFacetParent).removeClass('product__selected-no-flavor');
                }
            }
        }
    }
}

function toggleMobileList() {
    let $this = $(this);
    $this.toggleClass(IS_ACTIVE);
    $this.siblings('.product__mobile-list').toggleClass(IS_ACTIVE);
    let isExpanded = $this.hasClass(IS_ACTIVE);
    $this.attr('aria-expanded', isExpanded ? 'true' : 'false');
}

function selectMobileFacet() {
    let $this = $(this);
    let productName = $this.text();
    let facetType = $this.data('facet-type');
    let productType = $this.data('id');
    $('.product__mobile-list li').removeClass(IS_ACTIVE).attr('aria-selected', 'false');
    $this.addClass(IS_ACTIVE).attr('aria-selected', 'true');
    $(`.product__select input#${facetType}`).click();
    $(`.product__mobile-toggle`).removeClass('is--disabled-mobile');
    $(`.product__mobile-toggle[data-toggle-id="${productType}"] .product__mobile-selected`).text(productName);
    $this.parents('.product__mobile-list').removeClass(IS_ACTIVE);
    $this.parents('.product__mobile-list').siblings('.product__mobile-toggle').attr('aria-expanded', 'false');
}

function mobileSelectedFacets() {
    let $this = $(this);
    let checked = $this.data('display-name');
    let type = $this.parent('label').data('facet-type');
    $(`.product__mobile-toggle[data-toggle-id="${type}"] .product__mobile-selected`).text(checked);
}

function inputAda(e) {
    let $this = $(this);
    if(e.which === 13) {
        $this.children('input').click();
    }
}

// load partials
function loadHeader() {
    let $product = $('.product');
    let productData = $product.data('product-details');
    productData = {...productData, subHeaderText: getSubHeaderValue() };
    let productHeaderHtml = productHeader(productData);
    $productHeading.append(productHeaderHtml);
}

function loadSubHeader() {
    try {
        let $element = $productHeading.find('.product-sub__header');
        const subheaderValue = getSubHeaderValue();
        if(subheaderValue) {
            if(!$element.length) {
                $element = $('<h2 class="product-sub__header" tabindex="0"></h2>');
                $productHeading.append($element);
            }
            $element = $productHeading.find('.product-sub__header');
            if($element.length) {
                $element.text(subheaderValue);
            }
        }
    } catch (error) {
        console.error('Failed to load sub header:', error);
    }
}

function getSubHeaderValue() {
    const currentProductDetails = $product.data('product-details');
    if(!currentProductDetails?.Products?.length) return;

    const hasKits = currentProductDetails.Kits?.length > 0;
    const currentProductId = hasKits && selectedKitProduct
        ? selectedKitProduct.Id
        : selectedProduct?.ID;

    if(!currentProductId) return;

    const matchedProduct = currentProductDetails.Products.find(p => p.ID === currentProductId);
    if(matchedProduct?.SubHeader) {
        return matchedProduct.SubHeader;
    }
    return null;
}

function checkPriceTypeOnLoad() {
    if($('.price__block.is--active').length === 0) {
        $('.price__block:first').find('input').click();
    } else {
        loadPaypalMessage();
    }
}

function getCustomerType() {
    let ct = $('.price__block.is--active').data('customertype');
    if(ct) {
        ct = ct.replace(/ /g, '-');
    }
    return ct;
}

function changeDateTimeForVisibility() {
    let dateTimeValue = $('#pricing-datetime');
    if(dateTimeValue.val()) {
        let value = `${dateTimeValue.val()}-07`;
        window.location.href = window.location.pathname + '?' + $.param({ 'showdate': value });
    }
}

function addGtmTagToProductView() {
    let lastEvent = window.ga_props[window.ga_props.length - 1];
    if(!lastEvent) return;
    var memberId = lastEvent.MemberId;
    var memberType = lastEvent.MemberType;
    var currency = lastEvent.Currency;
    var cultureCode = lastEvent.CultureCode;
    var catalog = lastEvent.CatalogName;
    let category;
    let marketingCloudUserId;
    let hasProducts = lastEvent.Products && lastEvent.Products.length > 0;
    if(hasProducts) {
        category = lastEvent.Products[0].ProductFamilyName;
        marketingCloudUserId = lastEvent.Products[0].MarketingCloudUserId;
    }
    var isagenixMemberSubType = lastEvent.IsagenixMemberSubType;
    var preferredCultureCode = lastEvent.PreferredCultureCode;
    var hasAutoship = lastEvent.HasAutoship;
    var canEnroll = lastEvent.CanEnroll;
    var hasIsaDelivery = lastEvent.HasIsaDelivery;
    var daysSinceEnrollment = lastEvent.DaysSinceEnrollment;
    setDataForAllProducts(catalog, category, currency, memberType, memberId, cultureCode, marketingCloudUserId, isagenixMemberSubType, preferredCultureCode, hasAutoship, canEnroll, hasIsaDelivery, daysSinceEnrollment);
    var products = {};
    if(hasProducts) {
        products = {
            'name': lastEvent.Products[0].ProductName,
            'id': lastEvent.Products[0].Sku,
            'price': lastEvent.Products[0].Price,
            'brand': lastEvent.Products[0].Brand,
            'category': lastEvent.Products[0].ProductFamilyName,
            'quantity': lastEvent.Products[0].Quantity
        };

        if(products && QUERY_ID) {
            products = { ...products, queryId: QUERY_ID };
        }
        if(products && INDEX_NAME) {
            products = { ...products, indexName: INDEX_NAME };
        }
    }

    productDetails(products);

    const params = new URLSearchParams(window.location.search);
    if(params.has('edit')) {
        addGtmTagForEditCart(products);
    }
}

function addGtmTagToAddToCart() {
    try {
        let lastEvent = window.ga_props[window.ga_props.length - 1];
        if(!lastEvent) return;
        var memberId = lastEvent.MemberId;
        var memberType = lastEvent.MemberType;
        var currency = lastEvent.Currency;
        var cultureCode = lastEvent.CultureCode;
        var catalog = lastEvent.CatalogName;
        var category = lastEvent.Products[0].ProductFamilyName;
        var marketingCloudUserId = lastEvent.Products[0].MarketingCloudUserId;
        var isagenixMemberSubType = lastEvent.IsagenixMemberSubType;
        var preferredCultureCode = lastEvent.PreferredCultureCode;
        var hasAutoship = lastEvent.HasAutoship;
        var canEnroll = lastEvent.CanEnroll;
        var hasIsaDelivery = lastEvent.HasIsaDelivery;
        var daysSinceEnrollment = lastEvent.DaysSinceEnrollment;
        setDataForAllProducts(catalog, category, currency, memberType, memberId, cultureCode, marketingCloudUserId, isagenixMemberSubType, preferredCultureCode, hasAutoship, canEnroll, hasIsaDelivery, daysSinceEnrollment);
        var products = {
            'name': lastEvent.Products[0].ProductName,
            'id': lastEvent.Products[0].Sku,
            'price': lastEvent.Products[0].Price, // need to get the selected price
            'brand': lastEvent.Products[0].Brand,
            'category': lastEvent.Products[0].ProductFamilyName,
            'quantity': lastEvent.Products[0].Quantity
        };
        if(products && QUERY_ID) {
            products = { ...products, queryId: QUERY_ID };
        }
        if(products && INDEX_NAME) {
            products = { ...products, indexName: INDEX_NAME };
        }
        if(isEdit && editOnLoadQuantity && (parseInt(editOnLoadQuantity) > parseInt(lastEvent.Products[0].Quantity))) {
            removeFromCart([products]);
        } else if(isEdit && editOnLoadQuantity && (parseInt(editOnLoadQuantity) < parseInt(lastEvent.Products[0].Quantity))) {
            addGtmTagToCart(products);
        } else if(isEdit === undefined || !isEdit) {
            addGtmTagToCart(products);
        }
    } catch (error) {
        console.error('An error occurred while pushing event to dataLayer:', error);
    }
}

// #region Main functions
function initEventHandlers() {
    if(!$product.length) return;
    let $body = $('body');
    let $pricePack = $('.price--pack');
    $product = $('.product');

    productData = $product.data('product-details');
    if(productData) {
        createLinkList = productData.LeanShareLinksList;
    }
    if(!createLinkList) {
        createLinkList = [];
    }
    $productGallery = $('.product-gallery');
    $productGalleryThumbnailSection = $('.product__gallery-thumbnail-section');
    $productDietaryRestrictions = $('.product__dietary-restrictions');
    $productDetailsDescription = $('.product__details-description');
    $productPriceDetail = $('.product__price-detail');
    $productPriceStickyHeaderSection = $('#product-price-sticky-header');
    infoBadgeDiv = $('.badge-container-info');
    labelBadgeDiv = $('.badge-container');
    $body.on('click', '.addCustomProductToCart', addCustomProductToCart);
    if(productData) {
        isAuthenticatedUser = productData.IsAuthenticatedUser;
        displayBV = productData.DisplayBV;
    }
    checkStock();

    let isIsaDeliveryPage = $('.product.upgraded-isa-delivery').length;
    if(isIsaDeliveryPage) {
        const isaDeliveryProduct = $product.data('custom-product-details');
        selectedProduct = isaDeliveryProduct.Products[0];
        updatePayPalPayIn4Verbiage();
        toggleStickyHeader('.product.upgraded-isa-delivery');
        $(window).on('scroll', function () {
            if(scrollTimeout) {
                clearTimeout(scrollTimeout);
            }
            scrollTimeout = setTimeout(function () {
                toggleStickyHeader('.product.upgraded-isa-delivery');
            }, 500);
        });
    }

    if(productData === null || productData === undefined) {
        return;
    }
    selectedProduct = productData.Products[0];
    var forAmbassaorOnly = $product.data('is-ambassador');
    isNotAmbassador = !!(forAmbassaorOnly === 'false' || forAmbassaorOnly === 'False');
    productData = { ...productData, IsNotAmbassador: isNotAmbassador };

    if(!productData.ShowNewRatingsAndReviews) {
        $(REVIEW_SECTION).remove();
    }
    if(productData.ShowNewRatingsAndReviews && (productData.AnnexReviewId === null || productData.AnnexReviewId.trim() === '')) {
        $(REVIEW_SECTION).remove();
    }

    if(productData.BackgroundColor) {
        $product.addClass(productData.BackgroundColor);
    }

    loadSearchValues();
    loadHeader();
    createGroupByFacets();
    checkNullPrices();
    checkForProducts();
    checkKits();
    updateProductShareUrl();
    sortFacets();
    checkMultiFacets();
    loadTooltip();
    checkCustomerType();
    sortPrice();
    checkStatus();
    postMessage(selectedProduct);
    loadSubHeader();
    addGtmTagToProductView();

    let $productSelect = $('.product__select');
    let $selectInput = $productSelect.find('input');
    $selectInput.on('click', selectedOption);
    if($pricePack) {
        $pricePack.find('[data-filter-by]').filter(':visible:first').find('input').click();
    }
    if($addToCartType) {
        $addToCartType.remove();
    }
    let $productLoad = $(`.${FILTER_BY}`).find('input:visible:first');
    let selected = preselectProduct();
    if(!selected) {
        $productLoad.first().click();
    }
    postMessage(selectedKitProduct || selectedProduct);
    let $copyToClipboardBtn = $('#btn_CopyToClipboard');
    let $productMobileToggle = $('.product__mobile-toggle');
    let $productMobileListItem = $('.product__mobile-list li');
    let checkedFacets = $('.product__select input:checked');
    let $productLabel = $('.product__label');
    let $productInput = $('.product__input');
    let $productPrice = $('.product__price');
    $productPrice.on('click', '.increase-items', increaseItems);
    $productPrice.on('click', '.decrease-items', decreaseItems);
    $('.product__price').on('blur', '.price__quantity-sign--amount', checkItemMaxMinQuantity);
    $body.on('click', '.addToCart', addToCart);
    $body.on('click', '.addIndividualLink', createALink);
    $body.on('click', '.copyShareLink', copyShareLink);
    $body.on('click', '.crossSellAddProduct', crossSellAddProduct);
    $body.on('click', '.crossSellAddPack', crossSellAddPack);
    $body.on('click', '.error__btn', closeMsg);
    $body.on('click', '.price__block input', showInput);
    $body.on('blur', 'input[name="quantity"]', validateItemQuantity);
    $copyToClipboardBtn.on('click', copyToClipboard);
    $productLabel.on('keypress', inputAda);
    $body.on('click', '#show-more', toggleDescription);
    $productInput.on('click', getUpdatedQuantity);
    $productInput.on('click', checkPriceType);
    // $body.on('click', '.product__input', checkHeight);
    $body.on('keyup', '.price__quantity-sign--amount', getUpdatedQuantityKey);
    $body.on('click', '.price__block input', setPriceType);
    $body.on('click', "input[name='priceType']", togglePricePointTooltip);

    // mobile dropdown list events
    checkedFacets.each(mobileSelectedFacets);
    $productMobileToggle.on('click', toggleMobileList);
    $productMobileListItem.on('click', selectMobileFacet);
    checkPriceTypeOnLoad();
    if(!productData.IsAssistedEnrollment) {
        displayPackPrice($('.price__block input:checked').attr('id'));
    }
    // breaks clib
    if(!$body.hasClass('patternlab__body')) {
        initCurrencyFormatter();
    }

    let $dateTimePicker = $('#pricing-datetime');
    if($dateTimePicker) {
        $dateTimePicker.on('change', changeDateTimeForVisibility);
    }
    if($(TRY_ONCE).length > 0) {
        if(isTryOnceProduct) {
            $(TRY_ONCE).prop('checked', true);
            if($('#tryonceSticky').length) {
                $('#tryonceSticky').prop('checked', true);
            }
        } else {
            $(TRY_ONCE).prop('checked', false);
            if($('#tryonceSticky').length) {
                $('#tryonceSticky').prop('checked', false);
            }
        }
    }

    const upgradedProductContainer = $('.product.upgraded-product').find('.product__details .price__single-quantity-selector .price__group');
    if($(upgradedProductContainer).length) {
        upgradedSectionOffSet = $(upgradedProductContainer).offset().top;
    }

    $(window).resize(function () {
        disableDropdownIfSingleItem('filter-by');
        disableDropdownIfSingleItem('filter');
        if($(upgradedProductContainer).length) {
            upgradedSectionOffSet = $(upgradedProductContainer).offset().top;
            toggleStickyHeader('.product.upgraded-product');
        }
        adjustStickyButtonsWidth();
    });

    $(window).on('scroll', function () {
        if(scrollTimeout) {
            clearTimeout(scrollTimeout);
        }
        scrollTimeout = setTimeout(function () {
            toggleStickyHeader('.product.upgraded-product');
            adjustStickyButtonsWidth();
        }, 200);
    });

    adjustStickyButtonsWidth();
    let $productPriceSticky = $('.product.upgraded-product');
    if($productPriceSticky.length) {
        $productPriceSticky.on('click', '.product_price-sticky-right-section .sticky-increase-items', increaseItems);
        $productPriceSticky.on('click', '.product_price-sticky-right-section .sticky-decrease-items', decreaseItems);
        $productPriceSticky.on('blur', '.product_price-sticky-right-section .sticky-quantity-input', checkItemMaxMinQuantity);
    }
    toggleStickyHeader('.product.upgraded-product');
    if($('.product.upgraded-product').length) {
        if($('.product.upgraded-product .sticky-product-name').text() === '') {
            const selectedRadioButton = $('.product.upgraded-product').find('input[type="radio"][name="priceType"]:checked');
            const $priceTypeLabel = $(selectedRadioButton).closest('label');
            populateStickyHeader($priceTypeLabel);
        }
    }

    if($('.product.upgraded-product').length) {
        let isServ = $('.product.upgraded-product.serv-pdp').length;
        let headerImgElement = $('.isa-header__container img.navbar-brand__image-logo');
        let stickyImageElement = $('#product-price-sticky-header .sticky-image-container img');
        if(isServ) {
            if($(stickyImageElement).length && $(headerImgElement).length) {
                $(stickyImageElement).attr('src', $(headerImgElement).attr('src'));
            }
        }
    }

    if($productGalleryThumbnailSection.length) {
        $productGalleryThumbnailSection.on('click', '.thumbnail-image', handleThumbnailClick);
    }

    let $sharelinkModalQtySelector = $('#sharelinkModal-qty-selector');
    if($sharelinkModalQtySelector.length) {
        $sharelinkModalQtySelector.on('click', '.increase-items', increaseItems);
        $sharelinkModalQtySelector.on('click', '.decrease-items', decreaseItems);
        $sharelinkModalQtySelector.on('blur', '.quantity-input', checkItemMaxMinQuantity);
    }
}

function displayBadges() {
    let selectedProductOrKit;
    if(selectedProduct) {
        selectedProductOrKit = selectedProduct;
    } else {
        selectedProductOrKit = selectedKitProduct;
    }
    $(labelBadgeDiv).empty();
    if(productData && productData.IsUpgradedPDP && selectedProductOrKit) {
        const updatedProduct = selectProductBadge(selectedProductOrKit);
        if(updatedProduct && updatedProduct.badge) {
            const infoBadgeHtml = infoBadge(updatedProduct);
            const labelBadgeHtml = labelBadge(updatedProduct);
            $(labelBadgeDiv).html(labelBadgeHtml);
            displayBadgeInfoHtml(infoBadgeHtml);
        }
    }
}

function displayBadgeInfoHtml(infoBadgeHtml) {
    infoBadgeDiv = $('.badge-container-info');

    if(infoBadgeDiv.length > 0) {
        $(infoBadgeDiv).empty();
        if(infoBadgeHtml && infoBadgeHtml !== '') {
            $(infoBadgeDiv).html(infoBadgeHtml);
        }
    }
}

function selectProductBadge(productOrKit) {
    let updatedProduct = productOrKit;
    if(productOrKit && productOrKit.Facets && productOrKit.Facets.length > 0) {
        const badgeInfoList = productOrKit.Facets.filter(f => f.BadgeInfo !== null).map(f => f.BadgeInfo);
        const lowestBadge = getLowestRankBadge(badgeInfoList);

        if(lowestBadge != null) {
            updatedProduct = { ...updatedProduct, badge: lowestBadge };
        }
    }

    return updatedProduct;
}

function getLowestRankBadge(badgeInfoList) {
    if(badgeInfoList.length === 0) return null;

    return badgeInfoList.reduce((lowest, badge) => {
        const rank = parseInt(badge.Rank, 10);
        if(isNaN(rank)) {
            return lowest;
        }
        return (lowest === null || rank < parseInt(lowest.Rank, 10)) ? badge : lowest;
    }, null);
}

function handleThumbnailClick() {
    let thumbnailOrder = $(this).data('order');
    let thumbnailElements = $('.product__gallery-thumbnail-section .thumbnail-image img');
    $(thumbnailElements).each(function () {
        $(this).removeClass('product__img-thumb-active');
        $(this).closest('.thumbnail-image').removeClass('is_active-img');
    });
    $(this).find('img').addClass('product__img-thumb-active');
    $(this).addClass('is_active-img');

    let $productGalleryMain = $('.product-gallery__main');
    if($productGalleryMain.length) {
        $productGalleryMain.slick('slickSetOption', 'speed', 200, true);
        $productGalleryMain.slick('slickGoTo', thumbnailOrder);
    }
}

function adjustStickyButtonsWidth() {
    const header = $('#product-price-sticky-header');
    if(header.length) {
        const priceSection = $(header).find('.product_price-sticky-right-section .price__group');
        if(priceSection.length) {
            const cancelEditButton = $(header).find('.product_price-sticky-right-section .price__group .cancel-edit.is--edit');
            const addToCartButton = $(header).find('.product_price-sticky-right-section .price__group .button.addToCart');
            if(cancelEditButton.length && addToCartButton.length) {
                if($(window).width() >= 768) {
                    $(cancelEditButton).width($(addToCartButton).outerWidth() - 2);
                } else {
                    $(cancelEditButton).css('width', '100%');
                }
            }
        }
    }
}

function postMessage(selectedProduct) {
    if(!selectedProduct) {
        console.warn('postMessage - selectedProduct is missing.');
        return;
    }
    var body = document.body;
    var html = document.documentElement;

    var height = Math.max(body.scrollHeight, body.offsetHeight,
        html.clientHeight, html.scrollHeight, html.offsetHeight);
    var sku = selectedProduct.Sku;
    var productName = $('.product__header').html().trim();
    var images = selectedProduct.Assets.find(ast => ast.AssetType === 'Image');
    var imageUrl = '';
    if(images.length > 1) {
        imageUrl = images[0].Uri;
    } else {
        imageUrl = images.Uri;
    }

    var host = window.location.origin;
    imageUrl = host + imageUrl;

    var productUrl = window.location.href;

    var qs = new URLSearchParams(window.location.search);
    if(selectedProduct.ID == null && selectedProduct.Id == null) {
        qs.delete(PRODUCTID_QS);
    } else {
        qs.set(PRODUCTID_QS, selectedProduct.ID || selectedProduct.Id);
    }

    if(Array.from(qs).length > 0) {
        productUrl = `${window.location.pathname}?${qs.toString()}`;
    }
    var bpMessage = '{ "ProductId":"' + sku + '", "sku":"' + sku + '", "ProductUrl":"' + productUrl + '", "ProductImageUrl":"' + imageUrl + '", "ProductDisplayName":"' + productName + '", "WindowHeight":"' + height + '" }';
    window.parent.postMessage(bpMessage, '*');
}

$('.product.upgraded-product').on('change', 'input[type="checkbox"][name="tryonce"]', function () {
    const isSticky = $(this).attr('id') === 'tryonceSticky';
    if(this.checked) {
        if(isSticky) {
            $('#tryonce').prop('checked', true);
        } else {
            $('#tryonceSticky').prop('checked', true);
        }
    } else {
        if(isSticky) {
            $('#tryonce').prop('checked', false);
        } else {
            $('#tryonceSticky').prop('checked', false);
        }
    }
});

function togglePricePointTooltip() {
    let priceType = $("input[name='priceType']:checked").attr('id');
    if(priceType.includes('WholesaleRewards') || priceType.includes('NewMemberRewards')) {
        $('.price__row.has--promo').show();
        $('.price__promo button').show();
    } else if(priceType.includes('Wholesale') || priceType.includes('NewMember')) {
        $('.price__row.has--promo').show();
        $('.price__promo button').hide();
    } else {
        $('.price__row.has--promo').hide();
    }
    checkGAPropertiesUpdates({ eventName: 'PriceTypeSelection' });
    updateQuantityToDefault();
    updatePayPalPayIn4Verbiage();
    presaleMessage();
}

function updatePayPalPayIn4Verbiage() {
    let priceType = $("input[name='priceType']:checked").attr('id');

    var selectedPriceTier;
    if(selectedProduct && selectedProduct.PricesAndBV) {
        selectedPriceTier = selectedProduct.PricesAndBV.find(x => x.Tier === priceType);
    }

    if(selectedKitProduct && selectedKitProduct.PackPrices) {
        selectedPriceTier = selectedKitProduct.PackPrices.find(x => x.Tier === priceType);
    }

    const paypalDiv = document.querySelector('div[data-pp-amount]');
    if(paypalDiv && selectedPriceTier) {
        paypalDiv.setAttribute('data-pp-amount', selectedPriceTier.Price);
    }
}

function updateQuantityToDefault() {
    if(productData.EditProduct) {
        if(selectedProduct && productData.EditProduct.ProductId === selectedProduct.ID) {
            return;
        }
        if(selectedKitProduct && productData.EditProduct.ProductId === selectedKitProduct.Id) {
            return;
        }
    }
    $(`.price__single-quantity-selector input.price__quantity-sign--amount`).val(1);
    updateQuantityToZeroIfUnavailable();
}

function checkGAPropertiesUpdates(data) {
    let priceType = $("input[name='priceType']:checked").attr('id');
    let selectedPriceTier;
    let currProduct;
    let isKitOrBundle;
    if(selectedKitProduct) {
        currProduct = selectedKitProduct;
        isKitOrBundle = true;
        selectedPriceTier = selectedKitProduct.PackPrices.find(x => x.Tier === priceType);
    } else {
        if(selectedProduct) {
            currProduct = selectedProduct;
            if(selectedProduct.PricesAndBV) {
                isKitOrBundle = false;
                selectedPriceTier = selectedProduct.PricesAndBV.find(x => x.Tier === priceType);
            }
            if(selectedProduct.PackPrices) {
                isKitOrBundle = true;
                selectedProduct.PackPrices.find(x => x.Tier === priceType);
            }
        }
    }

    let initialEvent = window.ga_props[0];
    let newEvent = Object.assign({}, initialEvent);
    let price = selectedPriceTier && selectedPriceTier.Price ? selectedPriceTier.Price : 0;
    let productFamilyName = initialEvent.Products.length > 0 ? initialEvent.Products[0].ProductFamilyName : '';
    newEvent.EventName = data.eventName;
    newEvent.Products = [
        {
            Brand: 'Isagenix',
            ProductName: isKitOrBundle ? currProduct.PackName : selectedProduct.Name,
            id: currProduct.Sku,
            Price: price.toString(),
            ProductFamilyName: productFamilyName,
            Quantity: '1'
        }
    ];
    window.ga_props.push(newEvent);
}

function enableRetailPricePointOnPack() {
    let pgroup = $('#pack-price__group');
    let isPcPriceEnabled = $(pgroup).data('self-enroll-enabled');
    let isSubsPriceEnabled = $(pgroup).data('self-with-subscription-enroll-enabled');
    let isAuthenticated = $(pgroup).data('is-authenticated');
    let retailPriceButton = $('#retailPackBuilderButton');
    let retailPriceButtonSticky = $('#retailPackBuilderButtonSticky');
    let checkRadioButton = $('input[name=priceType]:checked');
    if(!isAuthenticated) {
        let guestChecked = $('#Retail-Checkout').is(':checked');
        let pcPriceChecked = false;
        let subscriptionChecked = true;
        let id = $(this).attr('id');
        if(id === undefined) {
            id = $(checkRadioButton).attr('id');
        }
        if(!guestChecked && id !== undefined) {
            if(id.toLowerCase().includes('rewards')) {
                subscriptionChecked = true;
                pcPriceChecked = false;
            } else {
                pcPriceChecked = true;
                subscriptionChecked = false;
            }
        }
        if(guestChecked) {
            $('button[data-enroll="true"]').addClass('d-none');
            $('button[data-enroll="false"]').addClass('d-none');
            $(retailPriceButton).removeClass('d-none');
            if($(retailPriceButtonSticky).length) {
                $(retailPriceButtonSticky).removeClass('d-none');
            }
        } else {
            if(pcPriceChecked) {
                if(isPcPriceEnabled) {
                    $('button[data-enroll="true"]').removeClass('d-none');
                    $('button[data-enroll="false"]').addClass('d-none');
                    $(retailPriceButton).addClass('d-none');
                    if($(retailPriceButtonSticky).length) {
                        $(retailPriceButtonSticky).addClass('d-none');
                    }
                } else {
                    $('button[data-enroll="true"]').addClass('d-none');
                    $('button[data-enroll="false"]').removeClass('d-none');
                    $(retailPriceButton).addClass('d-none');
                    if($(retailPriceButtonSticky).length) {
                        $(retailPriceButtonSticky).addClass('d-none');
                    }
                }
            }

            if(subscriptionChecked) {
                if(isSubsPriceEnabled) {
                    $('button[data-enroll="true"]').removeClass('d-none');
                    $('button[data-enroll="false"]').addClass('d-none');
                    $(retailPriceButton).addClass('d-none');
                    if($(retailPriceButtonSticky).length) {
                        $(retailPriceButtonSticky).addClass('d-none');
                    }
                } else {
                    $('button[data-enroll="true"]').addClass('d-none');
                    $('button[data-enroll="false"]').removeClass('d-none');
                    $(retailPriceButton).addClass('d-none');
                    if($(retailPriceButtonSticky).length) {
                        $(retailPriceButtonSticky).addClass('d-none');
                    }
                }
            }
        }
    }
}

function stopFlashUnstyledContentForPacks() {
    $(window).on('load', function () {
        $('body').css('visibility', 'visible');

        // hiding logic is on the backend
    });
}

function updateStickyQuantitySelector($this, quantity) {
    if(productData.IsUpgradedPDP) {
        let maxLimit = $('.product.upgraded-product .product__details .price__single-quantity-selector input.price__quantity-sign--amount').attr('max');
        let quantitySelectors = $('.product.upgraded-product .price__single-quantity-selector input.price__quantity-sign--amount');
        const increaseItems = $('.product.upgraded-product .price__single-quantity-selector .price__quantity-sign.increase-items');
        const decreaseItems = $('.product.upgraded-product .price__single-quantity-selector .price__quantity-sign.decrease-items');
        quantitySelectors.each(function () {
            $(this).val(quantity);
        });

        if(quantity > 1) {
            if(maxLimit !== null && quantity === parseFloat(maxLimit)) {
                increaseItems.each(function () {
                    if(!$(this).hasClass('is--disabled')) {
                        $(this).addClass('is--disabled');
                    }
                });
            } else {
                increaseItems.each(function () {
                    if($(this).hasClass('is--disabled')) {
                        $(this).removeClass('is--disabled');
                    }
                });
                decreaseItems.each(function () {
                    if($(this).hasClass('is--disabled')) {
                        $(this).removeClass('is--disabled');
                    }
                });
            }
        } else {
            increaseItems.each(function () {
                if($(this).hasClass('is--disabled')) {
                    $(this).removeClass('is--disabled');
                }
            });
            decreaseItems.each(function () {
                if(!$(this).hasClass('is--disabled')) {
                    $(this).addClass('is--disabled');
                }
            });
        }
    }
}

function presaleMessage() {
    var productjson = $('.product').data('product-details');

    var paramProd = new URLSearchParams(window.location.search);
    var prodId = paramProd.get('pid');
    var prod = productjson.Products.filter(function (product) {
        return product.ID === prodId;
    });

    if(prod.length > 0 && prod[0].PresaleData.IsValidPresaleItem && !prod[0].PresaleData.CanPurchase) {
        var msg = `<div class="product-unavailable-message presale-errormsg">
        <div class="product__unavailable">
            <p class="product-error product-error--unavailable" data-status="true">
            <span class="error-icon-unavailable"><i class="fal fa-exclamation-circle red900"></i></span>${prod[0].PresaleData.CannotPurchaseMessage}</p>
        </div>
    </div>`;

        $('.product-unavailable-message.presale-errormsg').remove();
        $('.product__details .product__price .price__group').after(msg);
        $('.product__details .product__price .price__group .addToCart').prop('disabled', true);
        $('.product__details .product__price .price__group .addToCart').removeClass('addToCart');
        $('.product__details .product__price .price__group .js-build-pack').prop('disabled', true);
        $('.product__details .product__price .price__group .js-build-pack').removeClass('js-build-pack');
    }
}

function addQueryIdToRequest(request) {
    if(
        request !== null &&
        typeof request === 'object' &&
        request.constructor === Object &&
        typeof QUERY_ID === 'string' &&
        QUERY_ID.trim() !== ''
    ) {
        return addGlobalQueryIdToRequest(request, QUERY_ID);
    }

    return request;
}

function loadSearchValues() {
    try {
        const params = new URLSearchParams(window.location.search);
        let queryId = null;
        for (const [key, value] of params.entries()) {
            if(key.toLowerCase() === 'qid') {
                queryId = value;
                break;
            }
        }

        if(queryId && queryId !== null) {
            QUERY_ID = queryId;
            INDEX_NAME = window?.algoliaData?.searchIndexName;
        }
    } catch (error) {
        console.error('Failed to load search cookie values:', error);
        QUERY_ID = null;
        INDEX_NAME = null;
    }
}

// #region Accessibility - ARIA Live Region & Keyboard Navigation

function createAriaLiveRegion() {
    if($('#pdp-aria-live-region').length === 0) {
        $('body').append('<div id="pdp-aria-live-region" role="status" aria-live="polite" aria-atomic="true" class="sr-only"></div>');
    }
}

function announceToScreenReader(message) {
    let $liveRegion = $('#pdp-aria-live-region');
    if($liveRegion.length) {
        $liveRegion.text('');
        setTimeout(function() {
            $liveRegion.text(message);
        }, 100);
    }
}

function announceSelectionChange(facetName) {
    if(facetName) {
        announceToScreenReader(facetName + ' selected');
    }
}

function announceQuantityChange(quantity) {
    if(quantity) {
        announceToScreenReader('Quantity changed to ' + quantity);
    }
}

function announceUnavailable(message) {
    if(message) {
        announceToScreenReader(message);
    }
}

function updateMobileListAriaSelected($selectedItem) {
    $selectedItem.siblings('li').attr('aria-selected', 'false');
    $selectedItem.attr('aria-selected', 'true');
}

function handleRadioGroupKeyboard(e) {
    let $this = $(this);
    let $radioGroup = $this.closest('.product__select');
    let $labels = $radioGroup.find('label[tabindex]:visible');
    let currentIndex = $labels.index($this);

    let newIndex = -1;
    switch (e.which) {
        case 37: // Left
        case 38: // Up
            e.preventDefault();
            newIndex = currentIndex > 0 ? currentIndex - 1 : $labels.length - 1;
            break;
        case 39: // Right
        case 40: // Down
            e.preventDefault();
            newIndex = currentIndex < $labels.length - 1 ? currentIndex + 1 : 0;
            break;
        case 13: // Enter
        case 32: // Space
            e.preventDefault();
            $this.find('input[type="radio"]').click();
            return;
    }

    if(newIndex >= 0) {
        let $newLabel = $labels.eq(newIndex);
        let $newInput = $newLabel.find('input[type="radio"]');
        if($newInput.length && !$newInput.prop('disabled')) {
            $labels.attr('tabindex', '-1');
            $newLabel.attr('tabindex', '0');
            $newLabel.focus();
            $newInput.click();
            // Announce the user's keyboard selection
            let displayName = $newInput.data('display-name') || $newLabel.find('.product__input-text').text();
            announceSelectionChange(displayName);
        }
    }
}

function handleMobileListKeyboard(e) {
    let $this = $(this);
    let $list = $this.closest('.product__mobile-list');
    let $items = $list.find('li:visible');
    let currentIndex = $items.index($this);

    let newIndex = -1;
    switch (e.which) {
        case 38: // Up
            e.preventDefault();
            newIndex = currentIndex > 0 ? currentIndex - 1 : $items.length - 1;
            break;
        case 40: // Down
            e.preventDefault();
            newIndex = currentIndex < $items.length - 1 ? currentIndex + 1 : 0;
            break;
        case 13: // Enter
        case 32: // Space
            e.preventDefault();
            $this.click();
            return;
        case 27: // Escape
            e.preventDefault();
            $list.removeClass('is--active');
            $list.siblings('.product__mobile-toggle').removeClass('is--active').focus();
            return;
    }

    if(newIndex >= 0) {
        $items.eq(newIndex).focus();
    }
}

function initAccessibilityHandlers() {
    createAriaLiveRegion();

    let $body = $('body');

    // Keyboard navigation for radio groups (arrow keys)
    $body.on('keydown', '.product__select label[tabindex]', handleRadioGroupKeyboard);

    // Keyboard navigation for mobile list items
    $body.on('keydown', '.product__mobile-list li', handleMobileListKeyboard);

    // Announce facet selection on mousedown (only fires for real user
    // mouse/touch interactions, never for programmatic .click() cascades)
    $body.on('mousedown', '.product__select label[tabindex]', function() {
        let $label = $(this);
        let $input = $label.find('.product__input');
        let displayName = $input.data('display-name') || $label.find('.product__input-text').text();
        if(displayName) {
            announceSelectionChange(displayName);
        }
    });

    // Update roving tabindex on click (mouse or programmatic)
    $body.on('click', '.product__input', function() {
        let $this = $(this);
        let $label = $this.closest('label');
        let $group = $label.closest('.product__select');
        $group.find('label[tabindex]').attr('tabindex', '-1');
        $label.attr('tabindex', '0');
    });

    // Announce mobile facet selection
    $body.on('click', '.product__mobile-list li', function() {
        let $this = $(this);
        updateMobileListAriaSelected($this);
        announceSelectionChange($this.text().trim());
    });

    // Toggle aria-expanded on mobile dropdown
    $body.on('click', '.product__mobile-toggle', function() {
        let $this = $(this);
        let isExpanded = $this.hasClass('is--active');
        $this.attr('aria-expanded', isExpanded ? 'true' : 'false');
    });

    // Announce quantity changes from buttons
    $body.on('click', '.increase-items, .decrease-items, .sticky-increase-items, .sticky-decrease-items', function() {
        let $container = $(this).closest('.isa-custom-qty-selector');
        let $input = $container.find('.price__quantity-sign--amount, .quantity-input');
        if($input.length) {
            let val = parseInt($input.val(), 10);
            announceQuantityChange(val);
        }
    });

    // Announce price type changes
    $body.on('click', '.price__block input[name="priceType"]', function() {
        let $priceBlock = $(this).closest('.price__block');
        let priceText = $priceBlock.find('.form-text--price').first().text().trim();
        let tierText = $priceBlock.find('.form-text--label').first().text().trim();
        if(priceText && tierText) {
            announceToScreenReader(tierText + ' selected, ' + priceText);
        }
    });
}

// #endregion Accessibility

$(function () {
    stopFlashUnstyledContentForPacks();
    initEventHandlers();
    initAccessibilityHandlers();

    // Sync roving tabindex to actual checked state after init
    $('.product__select').each(function() {
        let $group = $(this);
        let $checkedInput = $group.find('input[type="radio"]:checked');
        if($checkedInput.length) {
            $group.find('label[tabindex]').attr('tabindex', '-1');
            $checkedInput.closest('label').attr('tabindex', '0');
        }
    });

    $(".price__row-pack input[type='radio']").on('change', enableRetailPricePointOnPack);
    enableRetailPricePointOnPack();
});

// #endregion Main functions
